// v3 cache bust
// Load html2canvas and jsPDF dynamically
(function() {
   function loadScript(src, callback) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = function() {
         console.log('[OMIUS] Script loaded:', src.split('/').pop());
         if (callback) callback();
      };
      s.onerror = function() {
         console.error('[OMIUS] Failed to load script:', src);
         if (callback) callback();
      };
      document.head.appendChild(s);
   }

   loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js', function() {
      loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js', function() {
         // Load PDF.js separately — don't block customizer
         var pdfScript = document.createElement('script');
         pdfScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js';
         pdfScript.onload = function() {
            if (window['pdfjsLib']) {
               window['pdfjsLib'].GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';
               console.log('[OMIUS] PDF.js loaded successfully');
            } else {
               console.warn('[OMIUS] PDF.js loaded but pdfjsLib not found');
            }
         };
         pdfScript.onerror = function() {
            console.warn('[OMIUS] PDF.js failed to load — AI/PDF upload disabled');
         };
         document.head.appendChild(pdfScript);

         // Start customizer immediately — don't wait for PDF.js
         initHeadbandDesigner();
      });
   });
})();

function initHeadbandDesigner() {

   // ── BRAND MODE DETECTION ──
   // When URL has ?mode=brand, the customizer works in "brand design" mode:
   // no minimum quantity, no cart, submits design for Jay to create product manually
   var urlParams = new URLSearchParams(window.location.search);
   var isBrandMode = urlParams.get('mode') === 'brand';
   console.log('[OMIUS] Brand mode:', isBrandMode);

   // Model selection
   var currentModel = 'standard';
   var currentStep = 1;

   // Make functions available globally for event delegation
   window.hbToggleStep = function(n) {
      var body = document.getElementById('step' + n + 'Body');
      var step = document.getElementById('step' + n);
      if (body.classList.contains('step-open')) {
         body.classList.remove('step-open');
         step.classList.remove('step-active');
      } else {
         body.classList.add('step-open');
         step.classList.add('step-active');
      }
   };

   window.hbGoToStep = function(n) {
      for (var i = 1; i <= 3; i++) {
         var body = document.getElementById('step' + i + 'Body');
         var step = document.getElementById('step' + i);
         if (i === n) {
            body.classList.add('step-open');
            step.classList.add('step-active');
            step.classList.remove('step-completed');
         } else {
            body.classList.remove('step-open');
            step.classList.remove('step-active');
            if (i < n) {
               step.classList.add('step-completed');
            }
         }
      }
      updateStepSummaries();
      var targetStep = document.getElementById('step' + n);
      setTimeout(function() {
         var rect = targetStep.getBoundingClientRect();
         var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
         var headerOffset = 120;
         window.scrollTo({ top: rect.top + scrollTop - headerOffset, behavior: 'smooth' });
      }, 150);
      if (n === 3 && typeof updateHBPreview === 'function') {
         setTimeout(updateHBPreview, 200);
         setTimeout(updateDesignSummary, 250);
      }
      currentStep = n;
   };

   function updateStepSummaries() {
      var s1 = document.getElementById('step1Summary');
      if (s1) s1.innerText = currentModel === 'pro' ? 'Wide (30cm × 5.8cm)' : 'Classic (30cm × 3.8cm)';
      var s2 = document.getElementById('step2Summary');
      if (s2) {
         var logoSrc = document.getElementById('logoPreview');
         var hasLogo = logoSrc && logoSrc.src && logoSrc.style.display !== 'none';
         s2.innerText = hasLogo ? 'Design configured ✓' : 'Pending design';
      }
   }

   window.hbSelectModel = function(model) {
      currentModel = model;
      var stdCard = document.getElementById('modelStandard');
      var proCard = document.getElementById('modelPro');
      var previewContainer = document.querySelector('#omius-app-root .preview-container');
      var title = document.getElementById('configuratorTitle');
      var panelToggle = document.querySelector('#enableFrontPanel');
      var panelSection = document.getElementById('panelToggleSection');

      if (model === 'standard') {
         stdCard.style.borderColor = '#4a90d9';
         stdCard.style.boxShadow = '0 2px 8px rgba(74,144,217,0.15)';
         proCard.style.borderColor = '#ddd';
         proCard.style.boxShadow = 'none';
         previewContainer.style.height = '3.8cm';
         title.innerText = 'OMIUS HEADBAND CLASSIC (30cm x 3.8cm)';
         if (panelSection) panelSection.style.display = 'none';
         if (panelToggle) {
            panelToggle.checked = false;
            panelToggle.dispatchEvent(new Event('change'));
         }
         var cartBtn = document.getElementById('addToCartBtn');
         if (cartBtn && !isBrandMode) cartBtn.innerText = '🛒 ADD TO CART — $30.00';
      } else {
         proCard.style.borderColor = '#4a90d9';
         proCard.style.boxShadow = '0 2px 8px rgba(74,144,217,0.15)';
         stdCard.style.borderColor = '#ddd';
         stdCard.style.boxShadow = 'none';
         previewContainer.style.height = '5.8cm';
         title.innerText = 'OMIUS HEADBAND WIDE (30cm x 5.8cm)';
         if (panelSection) panelSection.style.display = 'block';
         var cartBtn = document.getElementById('addToCartBtn');
         if (cartBtn && !isBrandMode) cartBtn.innerText = '🛒 ADD TO CART — $35.00';
      }

      var bandWraps = document.querySelectorAll('#hbPreviewSection .hb-band-wrap');
      bandWraps.forEach(function(wrap) {
         wrap.style.paddingBottom = (model === 'standard') ? '13%' : '20%';
      });

      var flapOutline = document.querySelector('.hb-flap-outline');
      if (flapOutline) {
         // Sewn panel visible height: ~6cm. Classic band 3.8cm, Wide band 5.8cm
         flapOutline.style.top = (model === 'standard') ? '-12%' : '-2%';
         flapOutline.style.height = (model === 'standard') ? '124%' : '104%';
      }

      console.log('[OMIUS] Model set to:', currentModel);
      if (typeof updateHBPreview === 'function') updateHBPreview();
   };

   /* ═══════════════════════════════════════════════
      ORIGINAL CONFIGURATOR LOGIC
      ═══════════════════════════════════════════════ */

   var els = {
      elasticBand: document.getElementById('elasticBand'),
      topStripe: document.querySelector('#omius-app-root .top-stripe'),
      botStripe: document.querySelector('#omius-app-root .bottom-stripe'),
      stripeSelect: document.getElementById('stripeColor'),
      middleSelect: document.getElementById('middleColor'),
      middleHex: document.getElementById('middleColorHex'),
      logoArea: document.getElementById('logoContainer'),
      logoUpload: document.getElementById('logoUpload'),
      logoPreview: document.getElementById('logoPreview'),
      fileNameDisp: document.getElementById('fileNameDisplay'),
      radios: document.getElementsByName('placement'),
      logoSize: document.getElementById('logoSize'),
      sizeVal: document.getElementById('sizeValue'),
      logoCount: document.getElementById('logoCount'),
      countVal: document.getElementById('countValue'),
      countGroup: document.getElementById('countGroup'),
      logoSpacing: document.getElementById('logoSpacing'),
      spacingVal: document.getElementById('spacingValue'),
      spacingGroup: document.getElementById('spacingGroup'),
      canvasUpload: document.getElementById('canvasLogoUpload'),
      canvasLogo: document.getElementById('canvasLogo'),
      canvasFileDisp: document.getElementById('canvasFileNameDisplay'),
      canvasSize: document.getElementById('canvasLogoSize'),
      canvasSizeVal: document.getElementById('canvasSizeValue'),
      canvasBg: document.getElementById('canvasBgColor'),
      newCanvas: document.querySelector('#omius-app-root .new-canvas'),
      saveBtn: document.getElementById('savePdfBtn'),
      enablePanel: document.getElementById('enableFrontPanel'),
      canvasWrap: document.getElementById('canvasSectionWrap')
   };

   var state = { imgSrc: null, panelSrc: null, isRepeated: false, repeatedElements: [] };

   function updateColors(color) {
      var hex = color === 'white' ? '#ffffff' : '#000000';
      els.topStripe.style.backgroundColor = hex;
      els.botStripe.style.backgroundColor = hex;
      els.elasticBand.style.backgroundColor = hex;
      updateHBPreview();
   }

   function showQualityMsg(isMain, isSvg, width, height) {
      var msgEl = document.getElementById(isMain ? 'logoQualityMsg' : 'panelLogoQualityMsg');
      if (!msgEl) return;
      msgEl.style.display = 'block';
      if (isSvg) {
         msgEl.innerHTML = '<span style="color: #28a745;">✅ SVG — Perfect for print (vector, infinite resolution)</span>';
         return true;
      } else if (width >= 2000) {
         msgEl.innerHTML = '<span style="color: #28a745;">✅ High quality (' + width + '×' + height + 'px) — Ready for sublimation</span>';
         return true;
      } else if (width >= 1000) {
         msgEl.innerHTML = '<span style="color: #e6a700;">⚠️ Acceptable (' + width + '×' + height + 'px) — For best sublimation results, upload 2000px+ or SVG</span>';
         return true;
      } else {
         msgEl.innerHTML = '<span style="color: #dc3545;">❌ Too small (' + width + '×' + height + 'px) — Minimum 2000px wide required for sublimation quality. Please upload a larger image or SVG.</span>';
         return false;
      }
   }

   function handleUpload(file, imgEl, nameDisplay, isMain) {
      if(!file) return;
      nameDisplay.innerText = "✅ " + file.name;

      var fileName = file.name.toLowerCase();
      var isPdfOrAi = fileName.endsWith('.pdf') || fileName.endsWith('.ai') || file.type === 'application/pdf';

      // ── HANDLE PDF / AI ──
      // Illustrator .ai files are PDFs internally (PDF-compatible save)
      // Use PDF.js to render page 1 to a high-res canvas, then treat as PNG
      if (isPdfOrAi) {
         if (!window.pdfjsLib) {
            nameDisplay.innerText = '❌ PDF library not loaded, try again';
            return;
         }

         var msgEl = document.getElementById(isMain ? 'logoQualityMsg' : 'panelLogoQualityMsg');
         if (msgEl) {
            msgEl.style.display = 'block';
            msgEl.innerHTML = '<span style="color: #666;">⏳ Converting ' + (fileName.endsWith('.ai') ? '.AI' : '.PDF') + ' file...</span>';
         }

         var reader = new FileReader();
         reader.onload = function(e) {
            var typedArray = new Uint8Array(e.target.result);

            window.pdfjsLib.getDocument({ data: typedArray }).promise.then(function(pdf) {
               // Always use page 1 (where the logo typically lives)
               return pdf.getPage(1);
            }).then(function(page) {
               // Render at high resolution for print quality
               // scale 4 means 4x the default (72 DPI) = 288 DPI effective
               var viewport = page.getViewport({ scale: 8 });
               var canvas = document.createElement('canvas');
               canvas.width = viewport.width;
               canvas.height = viewport.height;
               var ctx = canvas.getContext('2d');

               // NO white background — preserve transparency from original PDF/AI
               // This way logos look clean on any band color (no white box around them)

               return page.render({ canvasContext: ctx, viewport: viewport }).promise.then(function() {
                  return canvas;
               });
            }).then(function(canvas) {
               var pngUrl = canvas.toDataURL('image/png');
               console.log('[OMIUS] PDF/AI converted: ' + canvas.width + 'x' + canvas.height + 'px');

               // Show quality message (always good since we render at 4x)
               if (msgEl) {
                  msgEl.innerHTML = '<span style="color: #28a745;">✅ ' + (fileName.endsWith('.ai') ? 'AI' : 'PDF') + ' file converted (' + canvas.width + '×' + canvas.height + 'px) — Ready for sublimation</span>';
               }

               applyUpload(pngUrl, imgEl, isMain);
            }).catch(function(err) {
               console.error('[OMIUS] PDF/AI conversion error:', err);
               if (msgEl) {
                  msgEl.innerHTML = '<span style="color: #dc3545;">❌ Could not convert file. Please try PNG, JPG, or SVG instead.</span>';
               }
               nameDisplay.innerText = '📂 Click to Choose File';
               if (isMain) { state.imgSrc = null; } else { state.panelSrc = null; }
            });
         };
         reader.readAsArrayBuffer(file);
         return;
      }

      // ── HANDLE PNG / JPG / SVG (original flow) ──
      var reader = new FileReader();
      reader.onload = function(e) {
         var dataUrl = e.target.result;
         var isSvg = file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg');
         if (isSvg) {
            showQualityMsg(isMain, true, 0, 0);
            var svgImg = new Image();
            svgImg.onload = function() {
               var w = svgImg.naturalWidth || 800;
               var h = svgImg.naturalHeight || 400;
               var scale = 8;
               var cvs = document.createElement('canvas');
               cvs.width = w * scale;
               cvs.height = h * scale;
               var ctx = cvs.getContext('2d');
               ctx.drawImage(svgImg, 0, 0, cvs.width, cvs.height);
               var pngUrl = cvs.toDataURL('image/png');
               applyUpload(pngUrl, imgEl, isMain);
            };
            svgImg.src = dataUrl;
         } else {
            var checkImg = new Image();
            checkImg.onload = function() {
               var accepted = showQualityMsg(isMain, false, checkImg.naturalWidth, checkImg.naturalHeight);
               if (checkImg.naturalWidth < 1000) {
                  // Too small — don't apply
                  nameDisplay.innerText = '📂 Click to Choose File';
                  if (isMain) { state.imgSrc = null; } else { state.panelSrc = null; }
                  imgEl.src = '';
                  imgEl.style.display = 'none';
                  return;
               }
               applyUpload(dataUrl, imgEl, isMain);
            };
            checkImg.src = dataUrl;
         }
      };
      reader.readAsDataURL(file);
   }

   // ─── AUTO-TRIM LOGO ──────────────────────────────────────────
   // Smart logo cleanup:
   //  1. Detects if the logo has a white/transparent background (Illustrator artboard)
   //     vs a colored background (intentional, like a logo on a colored badge).
   //  2. If white background → converts whites to transparent (fixes artboard issue).
   //  3. If colored background → preserves whites (they may be part of the design).
   //  4. Always trims empty margins around the actual content.
   function autoTrimLogo(dataUrl) {
      return new Promise(function(resolve) {
         var img = new Image();
         img.onload = function() {
            try {
               var w = img.naturalWidth;
               var h = img.naturalHeight;
               if (!w || !h) { resolve(dataUrl); return; }

               var cvs = document.createElement('canvas');
               cvs.width = w;
               cvs.height = h;
               var ctx = cvs.getContext('2d');
               ctx.drawImage(img, 0, 0);

               var imageData;
               try {
                  imageData = ctx.getImageData(0, 0, w, h);
               } catch(e) {
                  resolve(dataUrl);
                  return;
               }

               var data = imageData.data;
               var WHITE_THRESHOLD = 240;
               var COLOR_TOLERANCE = 30;

               // ── Step 1: Sample the 4 corners to detect background type ──
               function getPixel(x, y) {
                  var i = (y * w + x) * 4;
                  return { r: data[i], g: data[i+1], b: data[i+2], a: data[i+3] };
               }
               function isWhiteOrTransparent(p) {
                  if (p.a < 20) return true;
                  return p.r >= WHITE_THRESHOLD && p.g >= WHITE_THRESHOLD && p.b >= WHITE_THRESHOLD;
               }
               function colorsMatch(a, b) {
                  return Math.abs(a.r - b.r) <= COLOR_TOLERANCE &&
                         Math.abs(a.g - b.g) <= COLOR_TOLERANCE &&
                         Math.abs(a.b - b.b) <= COLOR_TOLERANCE;
               }

               // Sample corners with a small inset (5px) to avoid anti-aliasing
               var inset = Math.min(5, Math.floor(Math.min(w, h) * 0.02));
               var corners = [
                  getPixel(inset, inset),                  // top-left
                  getPixel(w - 1 - inset, inset),          // top-right
                  getPixel(inset, h - 1 - inset),          // bottom-left
                  getPixel(w - 1 - inset, h - 1 - inset)   // bottom-right
               ];

               var whiteCorners = corners.filter(isWhiteOrTransparent).length;
               var allWhite = whiteCorners === 4;
               var allColored = whiteCorners === 0 &&
                                colorsMatch(corners[0], corners[1]) &&
                                colorsMatch(corners[1], corners[2]) &&
                                colorsMatch(corners[2], corners[3]);

               var convertWhitesToTransparent = false;
               var bgType = 'unknown';

               if (allWhite) {
                  // All 4 corners are white/transparent → it's an artboard background
                  // Safe to convert all whites to transparent
                  convertWhitesToTransparent = true;
                  bgType = 'white-artboard';
               } else if (allColored) {
                  // All 4 corners share the same non-white color → intentional colored bg
                  // Preserve whites (they're part of the design)
                  convertWhitesToTransparent = false;
                  bgType = 'colored-bg';
               } else {
                  // Mixed corners → ambiguous, play it safe and preserve whites
                  convertWhitesToTransparent = false;
                  bgType = 'mixed';
               }

               // ── Step 2: Apply transparency conversion if applicable ──
               if (convertWhitesToTransparent) {
                  for (var i = 0; i < data.length; i += 4) {
                     if (data[i] >= WHITE_THRESHOLD && data[i + 1] >= WHITE_THRESHOLD && data[i + 2] >= WHITE_THRESHOLD) {
                        data[i + 3] = 0;
                     }
                  }
                  ctx.putImageData(imageData, 0, 0);
               }

               // ── Step 3: Find bounding box of visible content ──
               var minX = w, minY = h, maxX = -1, maxY = -1;

               for (var y = 0; y < h; y++) {
                  for (var x = 0; x < w; x++) {
                     var i = (y * w + x) * 4;
                     var a = data[i + 3];
                     if (a < 20) continue;
                     // If we converted whites, anything visible is content.
                     // If we didn't, also skip pure whites at edges.
                     if (!convertWhitesToTransparent &&
                         data[i] >= WHITE_THRESHOLD && data[i + 1] >= WHITE_THRESHOLD && data[i + 2] >= WHITE_THRESHOLD) {
                        continue;
                     }
                     if (x < minX) minX = x;
                     if (y < minY) minY = y;
                     if (x > maxX) maxX = x;
                     if (y > maxY) maxY = y;
                  }
               }

               if (maxX < 0 || maxY < 0) { resolve(dataUrl); return; }

               // ── Step 4: Trim with 5% safety margin ──
               var contentW = maxX - minX + 1;
               var contentH = maxY - minY + 1;
               var marginX = Math.round(contentW * 0.05);
               var marginY = Math.round(contentH * 0.05);

               var trimX = Math.max(0, minX - marginX);
               var trimY = Math.max(0, minY - marginY);
               var trimW = Math.min(w - trimX, contentW + (marginX * 2));
               var trimH = Math.min(h - trimY, contentH + (marginY * 2));

               var trimmed = document.createElement('canvas');
               trimmed.width = trimW;
               trimmed.height = trimH;
               var tctx = trimmed.getContext('2d');
               tctx.drawImage(cvs, trimX, trimY, trimW, trimH, 0, 0, trimW, trimH);

               var pct = Math.round((1 - (trimW * trimH) / (w * h)) * 100);
               console.log('[OMIUS] Auto-trim: ' + w + 'x' + h + ' → ' + trimW + 'x' + trimH +
                          ' (' + pct + '% removed, bg=' + bgType + ')');

               resolve(trimmed.toDataURL('image/png'));
            } catch(err) {
               console.warn('[OMIUS] Auto-trim error, using original:', err);
               resolve(dataUrl);
            }
         };
         img.onerror = function() { resolve(dataUrl); };
         img.src = dataUrl;
      });
   }

   function applyUpload(dataUrl, imgEl, isMain) {
      // Auto-trim white/transparent margins so the logo fills its container
      autoTrimLogo(dataUrl).then(function(trimmedDataUrl) {
         applyUploadInternal(trimmedDataUrl, imgEl, isMain);
      });
   }

   function applyUploadInternal(dataUrl, imgEl, isMain) {
      imgEl.src = dataUrl;
      imgEl.style.display = 'block';
      if(isMain) {
         state.imgSrc = dataUrl;
         renderMainLogo();
         // Sync panel logo if "use same logo" is checked
         var sameLogoChk = document.getElementById('useSameLogoPanel');
         if (sameLogoChk && sameLogoChk.checked) {
            state.panelSrc = dataUrl;
            els.canvasLogo.src = dataUrl;
            els.canvasLogo.style.display = 'block';
            els.canvasFileDisp.innerText = '✅ Using headband logo';
            var scale = els.canvasSize.value / 100;
            els.canvasLogo.style.maxWidth = '100%';
            els.canvasLogo.style.maxHeight = '100%';
            els.canvasLogo.style.width = 'auto';
            els.canvasLogo.style.height = 'auto';
            els.canvasLogo.style.objectFit = 'contain';
            els.canvasLogo.style.transform = 'scale(' + scale + ')';
         }
      } else {
         state.panelSrc = dataUrl;
         var scale = els.canvasSize.value / 100;
         imgEl.style.maxWidth = (scale * 100) + '%';
         imgEl.style.maxHeight = (scale * 100) + '%';
         imgEl.style.width = 'auto';
         imgEl.style.height = 'auto';
         imgEl.style.objectFit = 'contain';
      }
      updateHBPreview();
   }

   function renderMainLogo() {
      if(!state.imgSrc) return;
      state.repeatedElements.forEach(function(el) { el.remove(); });
      state.repeatedElements = [];

      if(state.isRepeated) {
         els.logoPreview.style.display = 'none';
         els.countGroup.style.display = 'block';
         els.spacingGroup.style.display = 'block';
         els.logoArea.style.padding = '0 5mm';

         var tempImg = new Image();
         tempImg.onload = function() {
            var fullContainerW = els.logoArea.offsetWidth;
            var containerH = els.logoArea.offsetHeight;
            var count = parseInt(els.logoCount.value);
            var requestedScale = els.logoSize.value / 100;
            var imgRatio = tempImg.width / tempImg.height;
            var paddingPx = 5 * 3.7795275591;
            var containerW = fullContainerW - (2 * paddingPx);
            var minSpacingRatio = parseInt(els.logoSpacing.value) / 100;
            var availablePerLogo = containerW / (count + (count + 1) * minSpacingRatio);
            var maxHeight = availablePerLogo / imgRatio;
            var scaledHeight = containerH * requestedScale;
            if (maxHeight < scaledHeight) scaledHeight = maxHeight;
            var scaledWidth = scaledHeight * imgRatio;
            var positions = [];
            if (count === 1) {
               positions.push((containerW - scaledWidth) / 2);
            } else {
               var availableWidth = containerW - (count * scaledWidth);
               var spacing = availableWidth / (count - 1);
               for(var i=0; i<count; i++) {
                  positions.push(i * (scaledWidth + spacing));
               }
            }
            positions.forEach(function(leftPos) {
               var img = document.createElement('img');
               img.src = state.imgSrc;
               img.style.position = 'absolute';
               img.style.top = '50%';
               img.style.transform = 'translateY(-50%)';
               img.style.height = scaledHeight + 'px';
               img.style.width = 'auto';
               img.style.left = (paddingPx + leftPos) + 'px';
               img.style.objectFit = 'contain';
               img.style.objectPosition = 'center';
               els.logoArea.appendChild(img);
               state.repeatedElements.push(img);
            });
         };
         tempImg.src = state.imgSrc;
      } else {
         els.logoPreview.style.display = 'block';
         els.countGroup.style.display = 'none';
         els.spacingGroup.style.display = 'none';
         els.logoArea.style.padding = '0';
         var scale = els.logoSize.value / 100;
         els.logoPreview.style.transform = 'scale(' + scale + ')';
      }
      updateHBPreview();
   }

   // Event listeners
   els.stripeSelect.onchange = function(e) { updateColors(e.target.value); };
   els.middleSelect.oninput = function(e) {
      var color = e.target.value;
      els.logoArea.style.backgroundColor = color;
      els.elasticBand.style.backgroundColor = color;
      if (els.middleHex) els.middleHex.value = color.toUpperCase();
      // Sync panel background if "use same color" is checked
      var sameColorChk = document.getElementById('useSameColorPanel');
      if (sameColorChk && sameColorChk.checked) {
         els.canvasBg.value = color;
         var canvasBgHexEl = document.getElementById('canvasBgHex');
         if (canvasBgHexEl) canvasBgHexEl.value = color.toUpperCase();
         els.newCanvas.style.background = color;
      }
      updateHBPreview();
   };
   if (els.middleHex) {
      function applyMiddleHex() {
         var val = els.middleHex.value.trim();
         if (val.charAt(0) !== '#') val = '#' + val;
         if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
            els.middleSelect.value = val;
            els.logoArea.style.backgroundColor = val;
            els.middleHex.value = val.toUpperCase();
            // Sync panel background if "use same color" is checked
            var sameColorChk = document.getElementById('useSameColorPanel');
            if (sameColorChk && sameColorChk.checked) {
               els.canvasBg.value = val;
               var canvasBgHexEl = document.getElementById('canvasBgHex');
               if (canvasBgHexEl) canvasBgHexEl.value = val.toUpperCase();
               els.newCanvas.style.background = val;
            }
            updateHBPreview();
         }
      }
      els.middleHex.onchange = applyMiddleHex;
      els.middleHex.onkeydown = function(e) {
         if (e.key === 'Enter') { applyMiddleHex(); e.preventDefault(); }
      };
      els.middleHex.onfocus = function() { this.select(); };
   }
   els.logoUpload.onchange = function(e) { handleUpload(e.target.files[0], els.logoPreview, els.fileNameDisp, true); };
   // Expand accepted file types to include PDF and AI
   if (els.logoUpload) {
      els.logoUpload.setAttribute('accept', '.png,.jpg,.jpeg,.svg,.pdf,.ai,image/png,image/jpeg,image/svg+xml,application/pdf,application/postscript');
   }
   Array.prototype.forEach.call(els.radios, function(r) {
      r.onchange = function() {
         state.isRepeated = (document.querySelector('input[name="placement"]:checked').value === 'repeated');
         renderMainLogo();
      };
   });
   els.logoSize.oninput = function(e) { els.sizeVal.innerText = e.target.value + '%'; renderMainLogo(); };
   els.logoCount.oninput = function(e) { els.countVal.innerText = e.target.value; renderMainLogo(); };
   els.logoSpacing.oninput = function(e) { els.spacingVal.innerText = e.target.value + '%'; renderMainLogo(); };
   els.canvasUpload.onchange = function(e) { handleUpload(e.target.files[0], els.canvasLogo, els.canvasFileDisp, false); };
   // Expand accepted file types to include PDF and AI
   if (els.canvasUpload) {
      els.canvasUpload.setAttribute('accept', '.png,.jpg,.jpeg,.svg,.pdf,.ai,image/png,image/jpeg,image/svg+xml,application/pdf,application/postscript');
   }
   els.canvasSize.oninput = function(e) {
      els.canvasSizeVal.innerText = e.target.value + '%';
      var scale = e.target.value / 100;
      els.canvasLogo.style.maxWidth = '100%';
      els.canvasLogo.style.maxHeight = '100%';
      els.canvasLogo.style.width = 'auto';
      els.canvasLogo.style.height = 'auto';
      els.canvasLogo.style.objectFit = 'contain';
      els.canvasLogo.style.transform = 'scale(' + scale + ')';
      updateHBPreview();
   };
   var canvasBgHex = document.getElementById('canvasBgHex');
   els.canvasBg.oninput = function(e) {
      els.newCanvas.style.background = e.target.value;
      canvasBgHex.value = e.target.value.toUpperCase();
      updateHBPreview();
   };
   canvasBgHex.onchange = function(e) {
      var val = e.target.value.trim();
      if (val.charAt(0) !== '#') val = '#' + val;
      if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
         els.canvasBg.value = val;
         els.newCanvas.style.background = val;
         canvasBgHex.value = val.toUpperCase();
         updateHBPreview();
      }
   };

   // Front panel checkbox toggle
   els.enablePanel.onchange = function() {
      if (this.checked) {
         els.canvasWrap.style.display = 'flex';
      } else {
         els.canvasWrap.style.display = 'none';
         state.panelSrc = null;
         els.canvasLogo.src = '';
         els.canvasLogo.style.display = 'none';
         els.canvasFileDisp.innerText = '📂 Click to Choose File';
         // Reset same-logo and same-color checkboxes when panel is disabled
         var sameLogoChk = document.getElementById('useSameLogoPanel');
         var sameColorChk = document.getElementById('useSameColorPanel');
         if (sameLogoChk) sameLogoChk.checked = false;
         if (sameColorChk) sameColorChk.checked = false;
         var panelUploadSec = document.getElementById('panelUploadSection');
         var panelColorSec = document.getElementById('panelColorSection');
         if (panelUploadSec) panelUploadSec.style.display = 'block';
         if (panelColorSec) panelColorSec.style.display = 'block';
      }
      updateHBPreview();
   };

   // "Use same logo as headband" checkbox
   var useSameLogoChk = document.getElementById('useSameLogoPanel');
   if (useSameLogoChk) {
      useSameLogoChk.onchange = function() {
         var panelUploadSec = document.getElementById('panelUploadSection');
         if (this.checked && state.imgSrc) {
            // Copy band logo to panel
            state.panelSrc = state.imgSrc;
            els.canvasLogo.src = state.imgSrc;
            els.canvasLogo.style.display = 'block';
            els.canvasFileDisp.innerText = '✅ Using headband logo';
            // Hide the upload section
            if (panelUploadSec) panelUploadSec.style.display = 'none';
            // Apply current panel size
            var scale = els.canvasSize.value / 100;
            els.canvasLogo.style.maxWidth = '100%';
            els.canvasLogo.style.maxHeight = '100%';
            els.canvasLogo.style.width = 'auto';
            els.canvasLogo.style.height = 'auto';
            els.canvasLogo.style.objectFit = 'contain';
            els.canvasLogo.style.transform = 'scale(' + scale + ')';
         } else if (this.checked && !state.imgSrc) {
            // No band logo uploaded yet
            this.checked = false;
            alert('Please upload a logo for the headband first.');
            return;
         } else {
            // Unchecked — clear panel logo and show upload section again
            state.panelSrc = null;
            els.canvasLogo.src = '';
            els.canvasLogo.style.display = 'none';
            els.canvasFileDisp.innerText = '📂 Click to Choose File';
            if (panelUploadSec) panelUploadSec.style.display = 'block';
         }
         updateHBPreview();
      };
   }

   // "Use same background color as headband" checkbox
   var useSameColorChk = document.getElementById('useSameColorPanel');
   if (useSameColorChk) {
      useSameColorChk.onchange = function() {
         var panelColorSec = document.getElementById('panelColorSection');
         if (this.checked) {
            // Copy headband middle color to panel background
            var headbandColor = els.middleSelect.value;
            els.canvasBg.value = headbandColor;
            var canvasBgHexEl = document.getElementById('canvasBgHex');
            if (canvasBgHexEl) canvasBgHexEl.value = headbandColor.toUpperCase();
            els.newCanvas.style.background = headbandColor;
            // Hide the color section
            if (panelColorSec) panelColorSec.style.display = 'none';
         } else {
            // Show the color section again
            if (panelColorSec) panelColorSec.style.display = 'block';
         }
         updateHBPreview();
      };
   }

   // PDF save
   els.saveBtn.onclick = function() {
      var prevText = els.saveBtn.innerText;
      els.saveBtn.innerText = "Processing...";

      var step3Body = document.getElementById('step3Body');
      var wasOpen = step3Body.classList.contains('step-open');
      step3Body.classList.add('step-open');
      step3Body.style.maxHeight = 'none';
      step3Body.style.overflow = 'visible';

      setTimeout(function() {
         var viewGrid = document.querySelector('#hbPreviewSection .hb-views-grid');
         var savedGridStyle = viewGrid ? viewGrid.style.cssText : '';
         if (viewGrid) {
            viewGrid.style.width = '2400px';
            viewGrid.style.gap = '20px';
         }

         var logoImgs = document.querySelectorAll('#hbPreviewSection [data-hb-band-main] img');
         logoImgs.forEach(function(img) {
            img.style.imageRendering = 'high-quality';
         });

         var opt = { scale: 3, useCORS: true, backgroundColor: null, allowTaint: true, logging: false, imageTimeout: 0 };

         var captures = [
            html2canvas(document.querySelector('#omius-app-root .preview-container'), opt)
         ];

         var panelEnabled = els.enablePanel.checked;
         if (panelEnabled) {
            captures.push(html2canvas(document.querySelector('#omius-app-root .new-canvas'), opt));
         }

         var previewSection = document.getElementById('hbPreviewSection');
         var viewCards = previewSection ? previewSection.querySelectorAll('.hb-view-card') : [];
         viewCards.forEach(function(card) {
            captures.push(html2canvas(card, { scale: 2, useCORS: true, backgroundColor: '#ffffff', allowTaint: true, logging: false, imageTimeout: 0 }));
         });

         Promise.all(captures).then(function(canvases) {
            var pageW = 420;
            var pageH = 297;
            var pdf = new jspdf.jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });

            var idx = 0;
            var bandCanvas = canvases[idx];
            var bandRatio = bandCanvas.width / bandCanvas.height;
            var bandW = pageW - 20;
            var bandH = bandW / bandRatio;

            pdf.setFontSize(16);
            pdf.setFont(undefined, 'bold');
            pdf.text('OMIUS HEADBAND — Print Template', pageW / 2, 15, { align: 'center' });
            pdf.setFontSize(10);
            pdf.setFont(undefined, 'normal');
            var modelLabel = currentModel === 'pro' ? 'Wide (30cm × 5.8cm)' : 'Classic (30cm × 3.8cm)';
            pdf.text('Model: ' + modelLabel, pageW / 2, 22, { align: 'center' });

            var bandImg = bandCanvas.toDataURL('image/png');
            pdf.addImage(bandImg, 'PNG', 10, 30, bandW, bandH);
            idx++;

            if (panelEnabled) {
               var panelCanvas = canvases[idx];
               var panelRatio = panelCanvas.width / panelCanvas.height;
               var panelH = pageH - bandH - 50;
               var panelW = panelH * panelRatio;
               if (panelW > 200) { panelW = 200; panelH = panelW / panelRatio; }
               var panelImg = panelCanvas.toDataURL('image/png');
               pdf.addImage(panelImg, 'PNG', 10, bandH + 40, panelW, panelH);
               idx++;
            }

            if (viewCards.length > 0) {
               pdf.addPage('a3', 'landscape');
               pdf.setFontSize(18);
               pdf.setFont(undefined, 'bold');
               pdf.text('HEADBAND PREVIEW', pageW / 2, 18, { align: 'center' });
               pdf.setFontSize(11);
               pdf.setFont(undefined, 'normal');
               pdf.text('Live preview of your custom design across all views', pageW / 2, 26, { align: 'center' });

               var margin = 15;
               var gapY = 8;
               var startY = 34;
               var availW = pageW - (margin * 2);
               var availH = pageH - startY - margin;
               var cellH = (availH - (gapY * 3)) / 4;

               for (var v = 0; v < 4 && (idx + v) < canvases.length; v++) {
                  var vc = canvases[idx + v];
                  var vImg = vc.toDataURL('image/png');
                  var vRatio = vc.width / vc.height;
                  var vW = availW;
                  var vH = vW / vRatio;
                  if (vH > cellH) { vH = cellH; vW = vH * vRatio; }
                  var oX = margin + (availW - vW) / 2;
                  var oY = startY + (v * (cellH + gapY)) + (cellH - vH) / 2;
                  pdf.addImage(vImg, 'PNG', oX, oY, vW, vH, '', 'NONE');
               }
            }

            // ═══ ORDER DETAILS PAGE ═══
            pdf.addPage('a3', 'landscape');
            pdf.setFontSize(18);
            pdf.setFont(undefined, 'bold');
            pdf.text('ORDER DETAILS', pageW / 2, 20, { align: 'center' });

            pdf.setDrawColor(51, 51, 51);
            pdf.setLineWidth(0.5);
            pdf.line(30, 24, pageW - 30, 24);

            var specs = getDesignSpecs();
            var fabricRgb = hexToRgb(specs.fabricColor);
            var biasTape = els.stripeSelect.value === 'white' ? 'White' : 'Black';
            var hasLogo = state.imgSrc ? 'Yes' : 'No';
            var qty = document.getElementById('orderQuantity');
            var qtyVal = qty && qty.value ? qty.value + ' units' : '—';

            var orderRows = [
               ['Quantity', qtyVal],
               ['Model', specs.model],
               ['Fabric Color', specs.fabricColor + '  (' + fabricRgb + ')'],
               ['Bias Tape', biasTape],
               ['Band Logo', hasLogo],
               ['Placement', specs.placement],
               ['Logo Size', specs.logoSize]
            ];

            if (specs.panelEnabled) {
               var panelRgb = hexToRgb(specs.panelBg);
               var hasPanelLogo = state.panelSrc ? 'Yes' : 'No';
               orderRows.push(['Front Panel', 'Yes']);
               orderRows.push(['Panel Background', specs.panelBg + '  (' + panelRgb + ')']);
               orderRows.push(['Panel Logo', hasPanelLogo]);
               orderRows.push(['Panel Logo Size', specs.panelSize]);
            } else {
               orderRows.push(['Front Panel', 'No']);
            }

            var rowStartY = 35;
            var rowH = 12;
            var labelX = 60;
            var valueX = pageW / 2 + 10;

            pdf.setFontSize(11);
            for (var r = 0; r < orderRows.length; r++) {
               var yPos = rowStartY + (r * rowH);
               // Alternating row background
               if (r % 2 === 0) {
                  pdf.setFillColor(245, 245, 245);
                  pdf.rect(50, yPos - 4, pageW - 100, rowH, 'F');
               }
               pdf.setFont(undefined, 'normal');
               pdf.setTextColor(136, 136, 136);
               pdf.text(orderRows[r][0], labelX, yPos + 3);
               pdf.setFont(undefined, 'bold');
               pdf.setTextColor(51, 51, 51);
               pdf.text(orderRows[r][1], valueX, yPos + 3);
            }

            // Reset text color
            pdf.setTextColor(0, 0, 0);

            // Date stamp at bottom
            var now = new Date();
            var dateStr = now.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
            pdf.setFontSize(9);
            pdf.setFont(undefined, 'normal');
            pdf.setTextColor(170, 170, 170);
            pdf.text('Generated: ' + dateStr, pageW / 2, pageH - 15, { align: 'center' });
            pdf.setTextColor(0, 0, 0);

            pdf.save('OMIUS-Print-File.pdf');
            els.saveBtn.innerText = prevText;

            step3Body.style.maxHeight = '';
            step3Body.style.overflow = '';
            if (!wasOpen) step3Body.classList.remove('step-open');
            if (viewGrid) viewGrid.style.cssText = savedGridStyle;
            logoImgs.forEach(function(img) {
               img.style.imageRendering = '';
            });
         });
      }, 150);
   };

   updateColors('black');

   /* ═══════════════════════════════════════════════
      DOWNLOAD PRINT FILES (300 DPI PNG)
      ═══════════════════════════════════════════════ */

   var DPI = 300;
   var CM_TO_PX = DPI / 2.54;

   // Inject 300 DPI pHYs chunk into PNG so programs read correct cm dimensions
   function pngWithDPI(dataUrl, dpi) {
      var base64 = dataUrl.split(',')[1];
      var bin = atob(base64);
      var bytes = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);

      // pHYs chunk: pixels per meter = dpi / 0.0254
      var ppm = Math.round(dpi / 0.0254);
      var phys = new Uint8Array(21);
      // Length = 9
      phys[0] = 0; phys[1] = 0; phys[2] = 0; phys[3] = 9;
      // Type = pHYs
      phys[4] = 0x70; phys[5] = 0x48; phys[6] = 0x59; phys[7] = 0x73;
      // X pixels per unit (4 bytes big-endian)
      phys[8]  = (ppm >> 24) & 0xff;
      phys[9]  = (ppm >> 16) & 0xff;
      phys[10] = (ppm >> 8) & 0xff;
      phys[11] = ppm & 0xff;
      // Y pixels per unit (4 bytes big-endian)
      phys[12] = (ppm >> 24) & 0xff;
      phys[13] = (ppm >> 16) & 0xff;
      phys[14] = (ppm >> 8) & 0xff;
      phys[15] = ppm & 0xff;
      // Unit = meter (1)
      phys[16] = 1;
      // CRC32 of type+data
      var crcData = phys.slice(4, 17);
      var crc = crc32(crcData);
      phys[17] = (crc >> 24) & 0xff;
      phys[18] = (crc >> 16) & 0xff;
      phys[19] = (crc >> 8) & 0xff;
      phys[20] = crc & 0xff;

      // Insert pHYs right after IHDR chunk (8 byte signature + 25 byte IHDR = offset 33)
      var before = bytes.slice(0, 33);
      var after = bytes.slice(33);
      var result = new Uint8Array(before.length + phys.length + after.length);
      result.set(before, 0);
      result.set(phys, before.length);
      result.set(after, before.length + phys.length);

      var blob = new Blob([result], { type: 'image/png' });
      return blob;
   }

   // Convert blob to data URL
   function blobToDataUrl(blob, callback) {
      var reader = new FileReader();
      reader.onload = function() { callback(reader.result); };
      reader.readAsDataURL(blob);
   }

   // CRC32 for PNG chunks
   function crc32(buf) {
      var table = [];
      for (var n = 0; n < 256; n++) {
         var c = n;
         for (var k = 0; k < 8; k++) {
            c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
         }
         table[n] = c;
      }
      var crc = 0xFFFFFFFF;
      for (var i = 0; i < buf.length; i++) {
         crc = table[(crc ^ buf[i]) & 0xFF] ^ (crc >>> 8);
      }
      return (crc ^ 0xFFFFFFFF) >>> 0;
   }

   function getDesignSpecs() {
      var modelLabel = currentModel === 'pro' ? 'Wide (30cm × 5.8cm)' : 'Classic (30cm × 3.8cm)';
      var stripeColor = els.stripeSelect.value === 'white' ? '#FFFFFF' : '#000000';
      var middleColor = els.middleSelect.value.toUpperCase();
      var placement = state.isRepeated ? 'Repeated × ' + (parseInt(els.logoCount.value) || 3) : 'Centered';
      var logoSize = els.logoSize.value + '%';
      var panelEnabled = els.enablePanel.checked;
      var panelBg = els.canvasBg.value.toUpperCase();
      var panelSize = els.canvasSize.value + '%';

      return {
         model: modelLabel,
         stripeColor: stripeColor,
         fabricColor: middleColor,
         placement: placement,
         logoSize: logoSize,
         panelEnabled: panelEnabled,
         panelBg: panelBg,
         panelSize: panelSize
      };
   }

   function hexToRgb(hex) {
      var r = parseInt(hex.substr(1,2), 16);
      var g = parseInt(hex.substr(3,2), 16);
      var b = parseInt(hex.substr(5,2), 16);
      return 'RGB(' + r + ', ' + g + ', ' + b + ')';
   }

   function updateDesignSummary() {
      var specs = getDesignSpecs();
      var el = document.getElementById('summaryContent');
      if (!el) return;

      var fabricHex = specs.fabricColor;
      var fabricRgb = hexToRgb(fabricHex);
      var biasTape = els.stripeSelect.value === 'white' ? 'White' : 'Black';
      var hasLogo = state.imgSrc ? '✅ Uploaded' : '❌ Not uploaded';

      var row = function(label, value) {
         return '<div style="display: flex; justify-content: space-between; padding: 6px 0; border-bottom: 1px solid #eee;"><span style="color: #888; font-size: 13px;">' + label + '</span><strong style="font-size: 13px;">' + value + '</strong></div>';
      };
      var colorRow = function(label, hex, extra) {
         return '<div style="display: flex; justify-content: space-between; align-items: center; padding: 6px 0; border-bottom: 1px solid #eee;"><span style="color: #888; font-size: 13px;">' + label + '</span><span style="display: flex; align-items: center; gap: 8px;"><span style="width: 16px; height: 16px; border-radius: 3px; background: ' + hex + '; border: 1px solid #ccc; display: inline-block;"></span><strong style="font-size: 13px;">' + hex + (extra ? ' · ' + extra : '') + '</strong></span></div>';
      };

      var html = '';
      html += '<div style="text-align: center; padding: 8px 0 10px; border-bottom: 2px solid #333; margin-bottom: 6px;"><strong style="font-size: 14px; letter-spacing: 1px;">ORDER DETAILS</strong></div>';
      var qty = document.getElementById('orderQuantity');
      var qtyVal = qty && qty.value ? qty.value + ' units' : '—';
      html += row('Quantity', qtyVal);
      html += row('Model', specs.model);
      html += colorRow('Fabric Color', fabricHex, fabricRgb);
      html += row('Bias Tape', biasTape);
      html += row('Band Logo', hasLogo);
      html += row('Placement', specs.placement);
      html += row('Logo Size', specs.logoSize);

      if (specs.panelEnabled) {
         var panelHex = specs.panelBg;
         var panelRgb = hexToRgb(panelHex);
         var hasPanelLogo = state.panelSrc ? '✅ Uploaded' : '❌ Not uploaded';
         html += row('Front Panel', 'Yes');
         html += colorRow('Panel Background', panelHex, panelRgb);
         html += row('Panel Logo', hasPanelLogo);
      } else {
         html += row('Front Panel', 'No');
      }

      el.innerHTML = html;
   }

   function renderBandPNG(callback) {
      var bandW_cm = 31;
      var bandH_cm = currentModel === 'pro' ? 5.8 : 3.8;
      var w = Math.round(bandW_cm * CM_TO_PX);
      var h = Math.round(bandH_cm * CM_TO_PX);

      var cvs = document.createElement('canvas');
      cvs.width = w;
      cvs.height = h;
      var ctx = cvs.getContext('2d');

      // Background - fabric color only
      var fabricColor = els.middleSelect.value;
      ctx.fillStyle = fabricColor;
      ctx.fillRect(0, 0, w, h);

      if (!state.imgSrc) {
         callback(cvs);
         return;
      }

      var logoImg = new Image();
      logoImg.onload = function() {
         var scale = els.logoSize.value / 100;

         if (state.isRepeated) {
            var count = parseInt(els.logoCount.value) || 3;
            var imgRatio = logoImg.width / logoImg.height;
            var slotW = w / count;
            var logoH = h * scale;
            var logoW = logoH * imgRatio;
            if (logoW > slotW * 0.9) {
               logoW = slotW * 0.9;
               logoH = logoW / imgRatio;
            }

            for (var i = 0; i < count; i++) {
               var cx = (slotW * i) + (slotW - logoW) / 2;
               var cy = (h - logoH) / 2;
               ctx.drawImage(logoImg, cx, cy, logoW, logoH);
            }
         } else {
            var imgRatio = logoImg.width / logoImg.height;
            var logoH = h * scale;
            var logoW = logoH * imgRatio;
            if (logoW > w * 0.9) {
               logoW = w * 0.9;
               logoH = logoW / imgRatio;
            }
            var cx = (w - logoW) / 2;
            var cy = (h - logoH) / 2;
            ctx.drawImage(logoImg, cx, cy, logoW, logoH);
         }

         callback(cvs);
      };
      logoImg.src = state.imgSrc;
   }

   function renderPanelPNG(callback) {
      var panelW_cm = 9.6;
      var panelH_cm = 8.5;
      var w = Math.round(panelW_cm * CM_TO_PX);
      var h = Math.round(panelH_cm * CM_TO_PX);
      var marginCm = 1.5;
      var margin = Math.round(marginCm * CM_TO_PX);

      var cvs = document.createElement('canvas');
      cvs.width = w;
      cvs.height = h;
      var ctx = cvs.getContext('2d');

      // Background
      ctx.fillStyle = els.canvasBg.value;
      ctx.fillRect(0, 0, w, h);

      if (!state.panelSrc) {
         callback(cvs);
         return;
      }

      var logoImg = new Image();
      logoImg.onload = function() {
         var scale = els.canvasSize.value / 100;
         var areaW = w - (margin * 2);
         var areaH = h - (margin * 2);
         var imgRatio = logoImg.width / logoImg.height;
         var logoH = areaH * scale;
         var logoW = logoH * imgRatio;
         if (logoW > areaW) {
            logoW = areaW;
            logoH = logoW / imgRatio;
         }
         var cx = margin + (areaW - logoW) / 2;
         var cy = margin + (areaH - logoH) / 2;
         ctx.drawImage(logoImg, cx, cy, logoW, logoH);
         callback(cvs);
      };
      logoImg.src = state.panelSrc;
   }

   function downloadCanvas(canvas, filename) {
      var rawUrl = canvas.toDataURL('image/png');
      var blob = pngWithDPI(rawUrl, 300);
      var link = document.createElement('a');
      link.download = filename;
      link.href = URL.createObjectURL(blob);
      link.click();
   }

   function downloadDataUrl(dataUrl, filename) {
      var link = document.createElement('a');
      link.download = filename;
      link.href = dataUrl;
      link.click();
   }

   function downloadLogos() {
      if (state.imgSrc) {
         setTimeout(function() { downloadDataUrl(state.imgSrc, 'OMIUS-Logo-Band.png'); }, 500);
      }
      if (state.panelSrc && els.enablePanel.checked) {
         setTimeout(function() { downloadDataUrl(state.panelSrc, 'OMIUS-Logo-Panel.png'); }, 1000);
      }
   }

   document.getElementById('downloadPrintBtn').onclick = function() {
      var btn = this;
      btn.innerText = 'Generating...';
      generatePrintPDF(function(pdf) {
         var modelName = currentModel === 'pro' ? 'Wide' : 'Classic';
         pdf.save('OMIUS-Sublimation-' + modelName + '.pdf');
         downloadLogos();
         btn.innerText = 'DOWNLOAD PRINT FILES';
      });
   };

   function generatePrintPDF(callback) {
      var bandW_cm = 31;
      var bandH_cm = currentModel === 'pro' ? 5.8 : 3.8;
      var fabricColor = els.middleSelect.value;

      var pdf = new jspdf.jsPDF({
         orientation: 'landscape',
         unit: 'cm',
         format: [bandH_cm, bandW_cm]
      });

      var r = parseInt(fabricColor.substr(1,2), 16);
      var g = parseInt(fabricColor.substr(3,2), 16);
      var b = parseInt(fabricColor.substr(5,2), 16);
      pdf.setFillColor(r, g, b);
      pdf.rect(0, 0, bandW_cm, bandH_cm, 'F');

      function addLogoToPdf(done) {
         if (!state.imgSrc) { done(); return; }

         var logoImg = new Image();
         logoImg.onload = function() {
            var scale = els.logoSize.value / 100;
            var imgRatio = logoImg.width / logoImg.height;

            if (state.isRepeated) {
               var count = parseInt(els.logoCount.value) || 3;
               var slotW = bandW_cm / count;
               var logoH = bandH_cm * scale;
               var logoW = logoH * imgRatio;
               if (logoW > slotW * 0.9) {
                  logoW = slotW * 0.9;
                  logoH = logoW / imgRatio;
               }
               for (var i = 0; i < count; i++) {
                  var cx = (slotW * i) + (slotW - logoW) / 2;
                  var cy = (bandH_cm - logoH) / 2;
                  pdf.addImage(state.imgSrc, 'PNG', cx, cy, logoW, logoH, '', 'FAST');
               }
            } else {
               var logoH = bandH_cm * scale;
               var logoW = logoH * imgRatio;
               if (logoW > bandW_cm * 0.9) {
                  logoW = bandW_cm * 0.9;
                  logoH = logoW / imgRatio;
               }
               var cx = (bandW_cm - logoW) / 2;
               var cy = (bandH_cm - logoH) / 2;
               pdf.addImage(state.imgSrc, 'PNG', cx, cy, logoW, logoH, '', 'FAST');
            }
            done();
         };
         logoImg.src = state.imgSrc;
      }

      addLogoToPdf(function() {
         if (els.enablePanel.checked) {
            var panelW = 9.6;
            var panelH = 8.5;
            pdf.addPage([panelH, panelW], 'landscape');

            var pr = parseInt(els.canvasBg.value.substr(1,2), 16);
            var pg = parseInt(els.canvasBg.value.substr(3,2), 16);
            var pb = parseInt(els.canvasBg.value.substr(5,2), 16);
            pdf.setFillColor(pr, pg, pb);
            pdf.rect(0, 0, panelW, panelH, 'F');

            if (state.panelSrc) {
               var panelImg = new Image();
               panelImg.onload = function() {
                  var pScale = els.canvasSize.value / 100;
                  var marginCm = 1.5;
                  var areaW = panelW - (marginCm * 2);
                  var areaH = panelH - (marginCm * 2);
                  var pRatio = panelImg.width / panelImg.height;
                  var pH = areaH * pScale;
                  var pW = pH * pRatio;
                  if (pW > areaW) { pW = areaW; pH = pW / pRatio; }
                  var px = marginCm + (areaW - pW) / 2;
                  var py = marginCm + (areaH - pH) / 2;
                  pdf.addImage(state.panelSrc, 'PNG', px, py, pW, pH, '', 'FAST');
                  callback(pdf);
               };
               panelImg.src = state.panelSrc;
            } else {
               callback(pdf);
            }
         } else {
            callback(pdf);
         }
      });
   }

   /* ═══════════════════════════════════════════════
      4-VIEW HEADBAND PREVIEW LOGIC
      ═══════════════════════════════════════════════ */

   function fillVentGrid(containerId) {
      var container = document.getElementById(containerId);
      if (!container) return;
      for (var i = 0; i < 20; i++) {
         var cell = document.createElement('div');
         cell.className = 'hb-vent-cell';
         container.appendChild(cell);
      }
   }

   function fillVentGridSide(containerId) {
      var container = document.getElementById(containerId);
      if (!container) return;
      for (var i = 0; i < 10; i++) {
         var cell = document.createElement('div');
         cell.className = 'hb-vent-cell';
         container.appendChild(cell);
      }
   }

   fillVentGrid('hbFrontVent');
   fillVentGridSide('hbLeftVent');
   fillVentGridSide('hbRightVent');


   // SCALE RULER FOR BACK VIEW
   (function createBackRuler() {
      var backCard = document.getElementById('hbBack');
      if (!backCard) return;
      var viewCard = backCard.closest('.hb-view-card');
      if (!viewCard) return;
      var bandWrap = viewCard.querySelector('.hb-band-wrap');
      if (!bandWrap) return;
      var rulerWrap = document.createElement('div');
      rulerWrap.id = 'hbBackRuler';
      rulerWrap.style.cssText = 'position:relative;width:100%;height:28px;margin-bottom:4px;user-select:none;';
      var toggle = document.createElement('div');
      toggle.style.cssText = 'position:absolute;right:0;top:0;display:flex;font-size:10px;cursor:pointer;z-index:5;';
      var cmBtn = document.createElement('span');
      cmBtn.innerText = 'cm';
      cmBtn.style.cssText = 'padding:2px 8px;border:1px solid #ccc;border-radius:3px 0 0 3px;background:#4a90d9;color:white;font-weight:600;font-size:10px;line-height:14px;';
      var inBtn = document.createElement('span');
      inBtn.innerText = 'in';
      inBtn.style.cssText = 'padding:2px 8px;border:1px solid #ccc;border-left:none;border-radius:0 3px 3px 0;background:#f5f5f5;color:#666;font-weight:600;font-size:10px;line-height:14px;';
      toggle.appendChild(cmBtn);
      toggle.appendChild(inBtn);
      rulerWrap.appendChild(toggle);
      var svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('width','100%');
      svg.setAttribute('height','28');
      svg.style.cssText = 'display:block;';
      rulerWrap.appendChild(svg);
      bandWrap.parentNode.insertBefore(rulerWrap, bandWrap);
      function drawRuler(unit) {
         var totalCm = 29;
         while (svg.firstChild) svg.removeChild(svg.firstChild);
         var ns = 'http://www.w3.org/2000/svg';
         if (unit === 'cm') {
            for (var i = 0; i <= totalCm; i++) {
               var pct = (i / totalCm) * 100;
               var isMajor = (i % 5 === 0);
               var tickH = isMajor ? 14 : 7;
               var line = document.createElementNS(ns,'line');
               line.setAttribute('x1',pct+'%'); line.setAttribute('x2',pct+'%');
               line.setAttribute('y1',28-tickH); line.setAttribute('y2',28);
               line.setAttribute('stroke',isMajor?'#666':'#bbb');
               line.setAttribute('stroke-width',isMajor?'1.5':'0.75');
               svg.appendChild(line);
               if (isMajor && i > 0) {
                  var text = document.createElementNS(ns,'text');
                  text.setAttribute('x',pct+'%'); text.setAttribute('y',10);
                  text.setAttribute('text-anchor','middle'); text.setAttribute('fill','#888');
                  text.setAttribute('font-size','9');
                  text.textContent = i;
                  svg.appendChild(text);
               }
            }
            cmBtn.style.background='#4a90d9'; cmBtn.style.color='white';
            inBtn.style.background='#f5f5f5'; inBtn.style.color='#666';
         } else {
            var totalIn = totalCm / 2.54;
            var halfSteps = Math.floor(totalIn * 2);
            for (var i = 0; i <= halfSteps; i++) {
               var inches = i * 0.5;
               var cm = inches * 2.54;
               if (cm > totalCm) break;
               var pct = (cm / totalCm) * 100;
               var isWhole = (i % 2 === 0);
               var tickH = isWhole ? 14 : 7;
               var line = document.createElementNS(ns,'line');
               line.setAttribute('x1',pct+'%'); line.setAttribute('x2',pct+'%');
               line.setAttribute('y1',28-tickH); line.setAttribute('y2',28);
               line.setAttribute('stroke',isWhole?'#666':'#bbb');
               line.setAttribute('stroke-width',isWhole?'1.5':'0.75');
               svg.appendChild(line);
               if (isWhole && inches > 0) {
                  var text = document.createElementNS(ns,'text');
                  text.setAttribute('x',pct+'%'); text.setAttribute('y',10);
                  text.setAttribute('text-anchor','middle'); text.setAttribute('fill','#888');
                  text.setAttribute('font-size','9');
                  text.textContent = Math.round(inches) + '"';
                  svg.appendChild(text);
               }
            }
            inBtn.style.background='#4a90d9'; inBtn.style.color='white';
            cmBtn.style.background='#f5f5f5'; cmBtn.style.color='#666';
         }
         var bl = document.createElementNS(ns,'line');
         bl.setAttribute('x1','0'); bl.setAttribute('x2','100%');
         bl.setAttribute('y1',28); bl.setAttribute('y2',28);
         bl.setAttribute('stroke','#ddd'); bl.setAttribute('stroke-width','1');
         svg.appendChild(bl);
      }
      cmBtn.onclick = function() { drawRuler('cm'); };
      inBtn.onclick = function() { drawRuler('in'); };
      drawRuler('cm');
   })();

   function updateHBPreview() {
      console.log('[OMIUS] updateHBPreview called, currentModel:', currentModel);
      var stripeColor = els.stripeSelect.value === 'white' ? '#ffffff' : '#000000';
      var middleColor = els.middleSelect.value;
      var bandLogoSrc = state.imgSrc;
      var panelLogoSrc = state.panelSrc;
      var logoScale = els.logoSize.value / 100;
      var panelScale = els.canvasSize.value / 100;
      var panelBg = els.canvasBg.value;

      // Ensure stripes exist in each band-inner (create if missing)
      ['hbFront','hbBack','hbLeft','hbRight'].forEach(function(id) {
         var inner = document.getElementById(id);
         if (!inner) return;
         if (!inner.querySelector('[data-hb-stripe]')) {
            var top = document.createElement('div');
            top.className = 'hb-stripe hb-stripe-top';
            top.setAttribute('data-hb-stripe', '');
            var bot = document.createElement('div');
            bot.className = 'hb-stripe hb-stripe-bottom';
            bot.setAttribute('data-hb-stripe', '');
            inner.appendChild(top);
            inner.appendChild(bot);
         }
      });

      document.querySelectorAll('#hbPreviewSection [data-hb-stripe]').forEach(function(s) {
         var parentInner = s.closest('.hb-band-inner');
         if (!parentInner) return;
         var isFrontView = parentInner.id === 'hbFront';
         var isLeftView = parentInner.id === 'hbLeft';
         var isRightView = parentInner.id === 'hbRight';
         var isTop = s.classList.contains('hb-stripe-top');
         var pos = isTop ? 'top: 0;' : 'bottom: 0;';

         if (currentModel === 'standard') {
            if (isFrontView) {
               s.style.cssText = 'display: none !important;';
            } else if (isLeftView) {
               s.style.cssText = 'display: block !important; position: absolute !important; ' + pos + ' left: 43% !important; right: 0 !important; height: 17% !important; background: ' + stripeColor + ' !important; z-index: 10 !important;';
            } else if (isRightView) {
               s.style.cssText = 'display: block !important; position: absolute !important; ' + pos + ' left: 0 !important; right: 43% !important; height: 17% !important; background: ' + stripeColor + ' !important; z-index: 10 !important;';
            } else {
               s.style.cssText = 'display: block !important; position: absolute !important; ' + pos + ' left: 0 !important; right: 0 !important; height: 17% !important; background: ' + stripeColor + ' !important; z-index: 10 !important;';
            }
         } else {
            s.style.cssText = 'display: block !important; position: absolute !important; ' + pos + ' left: 0 !important; right: 0 !important; height: 17% !important; background: ' + stripeColor + ' !important; z-index: 10 !important;';
         }
      });

      var flapOutline = document.querySelector('.hb-flap-outline');
      var panelZone = document.querySelector('[data-hb-panel-logo]');
      if (currentModel === 'standard') {
         if (flapOutline) flapOutline.style.display = 'none';
         if (panelZone) panelZone.style.display = 'none';
      } else {
         // Panel in preview = sewn/visible size: ~7cm wide x ~6cm tall (vs full 9.6x8.5cm in configurator)
         if (flapOutline) { flapOutline.style.display = ''; flapOutline.style.left = '38.5%'; flapOutline.style.width = '23%'; }
         if (panelZone) { panelZone.style.display = ''; panelZone.style.left = '38.5%'; panelZone.style.width = '23%'; }
      }

      // Adjust vent zones based on model
      var frontVent = document.getElementById('hbFrontVent');
      var sideVents = [document.getElementById('hbLeftVent'), document.getElementById('hbRightVent')];

      if (currentModel === 'standard') {
         // Classic Front: vent covers full height
         if (frontVent) { frontVent.style.top = '0'; frontVent.style.height = '100%'; }
         // Classic sides: vent between stripes
         sideVents.forEach(function(vent) {
            if (!vent) return;
            vent.style.top = '17%';
            vent.style.height = '66%';
         });
      } else {
         // Wide: all vents between stripes
         if (frontVent) { frontVent.style.top = '17%'; frontVent.style.height = '66%'; }
         sideVents.forEach(function(vent) {
            if (!vent) return;
            vent.style.top = '17%';
            vent.style.height = '66%';
         });
      }

      var isDarkBg = false;
      try {
         var _r = parseInt(middleColor.substr(1,2), 16);
         var _g = parseInt(middleColor.substr(3,2), 16);
         var _b = parseInt(middleColor.substr(5,2), 16);
         isDarkBg = (_r * 0.299 + _g * 0.587 + _b * 0.114) < 128;
      } catch(ex) {}
      document.querySelectorAll('#hbPreviewSection .hb-band-inner').forEach(function(inner) {
         inner.style.backgroundColor = middleColor;
         inner.classList.remove('hb-dark-texture');
      });

      // Fabric backgrounds also get the color
      document.querySelectorAll('#hbPreviewSection [data-hb-fabric]').forEach(function(fabric) {
         fabric.style.backgroundColor = middleColor;
      });
      document.querySelectorAll('#hbPreviewSection .hb-middle-area').forEach(function(area) {
         area.style.backgroundColor = 'transparent';
      });

      var ventBorder = isDarkBg ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.22)';
      var ventBg = isDarkBg ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)';
      var ventShadow = isDarkBg ? 'inset 0 1px 2px rgba(255,255,255,0.04)' : 'inset 0 1px 2px rgba(0,0,0,0.06)';
      document.querySelectorAll('#hbPreviewSection .hb-vent-cell').forEach(function(cell) {
         cell.style.borderColor = ventBorder;
         cell.style.background = ventBg;
         cell.style.boxShadow = ventShadow;
      });
      document.querySelectorAll('#hbPreviewSection .hb-vent-zone').forEach(function(zone) {
         zone.style.backgroundColor = 'transparent';
      });
      document.querySelectorAll('#hbPreviewSection .hb-seam').forEach(function(seam) {
         seam.style.backgroundColor = 'transparent';
      });
      document.querySelectorAll('#hbPreviewSection .hb-seam-dash').forEach(function(dash) {
         dash.style.borderLeftColor = isDarkBg ? '#666' : '#bbb';
      });
      document.querySelectorAll('#hbPreviewSection [data-hb-separator]').forEach(function(bar) {
         bar.style.backgroundColor = isDarkBg ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.2)';
         if (currentModel === 'standard') {
            bar.style.top = '0';
            bar.style.height = '100%';
         } else {
            bar.style.top = '17%';
            bar.style.height = '66%';
         }
      });

      var isRepeated = state.isRepeated;
      var logoCount = parseInt(els.logoCount.value) || 3;

      document.querySelectorAll('[data-hb-band-main]').forEach(function(zone) {
         var emptyMsg = zone.querySelector('[data-hb-band-empty]');
         while (zone.firstChild) {
            if (zone.firstChild === emptyMsg) {
               if (zone.firstChild.nextSibling) {
                  zone.removeChild(zone.firstChild.nextSibling);
               } else {
                  break;
               }
            } else {
               zone.removeChild(zone.firstChild);
            }
         }
         var isSideView = zone.hasAttribute('data-hb-side');
         var isBackView = zone.hasAttribute('data-hb-back');

         if (!isRepeated && isSideView) {
            if (emptyMsg) emptyMsg.style.display = 'none';
            return;
         }

         if (!bandLogoSrc) {
            if (emptyMsg) emptyMsg.style.display = 'block';
            return;
         }

         if (emptyMsg) emptyMsg.style.display = 'none';

         if (isRepeated) {
            zone.style.display = 'flex';
            zone.style.flexDirection = 'row';
            zone.style.alignItems = 'center';
            zone.style.overflow = 'hidden';
            zone.style.padding = '0';
            zone.style.gap = '0';
            zone.style.position = 'absolute';

            if (isBackView) {
               zone.style.justifyContent = 'space-evenly';
               var slotWidthPct = Math.floor(95 / logoCount);
               for (var i = 0; i < logoCount; i++) {
                  var wrapper = document.createElement('div');
                  wrapper.style.width = slotWidthPct + '%';
                  wrapper.style.height = '100%';
                  wrapper.style.display = 'flex';
                  wrapper.style.alignItems = 'center';
                  wrapper.style.justifyContent = 'center';
                  wrapper.style.flexShrink = '0';
                  var img = document.createElement('img');
                  img.src = bandLogoSrc;
                  img.style.maxWidth = '100%';
                  img.style.maxHeight = '100%';
                  img.style.width = 'auto';
                  img.style.height = 'auto';
                  img.style.objectFit = 'contain';
                  img.style.transform = 'scale(' + logoScale + ')';
                  wrapper.appendChild(img);
                  zone.appendChild(wrapper);
               }
            } else {
               var isLeftView = zone.closest('#hbLeft') !== null;
               var sideRatio = 13 / 29;
               var visibleLogos = sideRatio * logoCount;
               var fullLogos = Math.floor(visibleLogos);
               var fractional = visibleLogos - fullLogos;
               var logosToRender = fractional > 0.05 ? fullLogos + 1 : fullLogos;

               zone.style.overflow = 'hidden';
               zone.style.display = 'flex';
               zone.style.flexDirection = 'row';
               zone.style.alignItems = 'center';
               zone.style.flexWrap = 'nowrap';
               zone.style.padding = '0';
               zone.style.gap = '0';
               zone.style.justifyContent = isLeftView ? 'flex-start' : 'flex-end';

               var slotWidthPct = Math.floor(95 / visibleLogos);
               var gapPct = (1 / visibleLogos) * 5;

               for (var i = 0; i < logosToRender; i++) {
                  var wrapper = document.createElement('div');
                  wrapper.style.width = slotWidthPct + '%';
                  wrapper.style.minWidth = slotWidthPct + '%';
                  wrapper.style.height = '100%';
                  wrapper.style.display = 'flex';
                  wrapper.style.alignItems = 'center';
                  wrapper.style.justifyContent = 'center';
                  wrapper.style.flexShrink = '0';
                  wrapper.style.marginLeft = (gapPct / 2) + '%';
                  wrapper.style.marginRight = (gapPct / 2) + '%';
                  var img = document.createElement('img');
                  img.src = bandLogoSrc;
                  img.style.maxWidth = '100%';
                  img.style.maxHeight = '100%';
                  img.style.width = 'auto';
                  img.style.height = 'auto';
                  img.style.objectFit = 'contain';
                  img.style.transform = 'scale(' + logoScale + ')';
                  wrapper.appendChild(img);
                  zone.appendChild(wrapper);
               }
            }
         } else {
            zone.style.display = 'flex';
            zone.style.alignItems = 'center';
            zone.style.justifyContent = 'center';
            zone.style.gap = '0';
            zone.style.padding = '0';

            var img = document.createElement('img');
            img.src = bandLogoSrc;
            img.style.transform = 'scale(' + logoScale + ')';
            img.style.transition = 'transform 0.2s ease';
            img.style.maxWidth = '95%';
            img.style.maxHeight = '100%';
            img.style.objectFit = 'contain';
            zone.appendChild(img);
         }
      });

      var panelEnabled = els.enablePanel.checked;
      // Preview shows sewn panel (~7x6cm visible vs 9.6x8.5cm full)
      // Logo fills ~1.37x more of visible area after sewing (9.6/7 ratio)
      var boostPanel = Math.min(panelScale * 4.2, 0.82);

      document.querySelectorAll('.hb-flap-outline').forEach(function(el) {
         el.style.display = panelEnabled ? 'block' : 'none';
      });

      document.querySelectorAll('[data-hb-panel-logo]').forEach(function(zone) {
         var existing = zone.querySelector('img');

         if (panelEnabled && panelLogoSrc) {
            zone.style.display = 'flex';
            if (existing) {
               existing.src = panelLogoSrc;
               existing.style.transform = 'scale(' + boostPanel + ')';
            } else {
               var img = document.createElement('img');
               img.src = panelLogoSrc;
               img.style.transform = 'scale(' + boostPanel + ')';
               img.style.transition = 'transform 0.2s ease';
               zone.appendChild(img);
            }
            zone.style.backgroundColor = panelBg;
         } else {
            if (existing) existing.remove();
            zone.style.backgroundColor = 'transparent';
            if (!panelEnabled) zone.style.display = 'none';
         }
      });

      updateDesignSummary();
   }

   // Attach click handlers that replace onclick attributes
   // Step headers
   document.querySelectorAll('#omius-app-root .step-header').forEach(function(header) {
      var step = header.closest('.step');
      if (step) {
         var stepNum = step.id.replace('step', '');
         header.addEventListener('click', function() { window.hbToggleStep(parseInt(stepNum)); });
      }
   });

   // Model cards
   var stdCard = document.getElementById('modelStandard');
   var proCard = document.getElementById('modelPro');
   if (stdCard) stdCard.addEventListener('click', function() { window.hbSelectModel('standard'); });
   if (proCard) proCard.addEventListener('click', function() { window.hbSelectModel('pro'); });

   // Step next buttons
   document.querySelectorAll('#omius-app-root .step-next-btn').forEach(function(btn) {
      var text = btn.textContent;
      if (text.indexOf('Continue') > -1) {
         btn.addEventListener('click', function() { window.hbGoToStep(2); });
      } else if (text.indexOf('Preview') > -1) {
         btn.addEventListener('click', function() { window.hbGoToStep(3); });
      }
   });

   // File upload boxes
   document.querySelectorAll('#omius-app-root .file-upload-box').forEach(function(box) {
      var input = box.querySelector('input[type="file"]');
      if (input) {
         box.addEventListener('click', function(e) {
            if (e.target !== input) input.click();
         });
      }
   });

   // Canvas BG quick buttons (White/Black)
   var canvasBgBtns = document.querySelectorAll('#omius-app-root #canvasSectionWrap button[type="button"]');
   if (canvasBgBtns.length >= 2) {
      canvasBgBtns[0].addEventListener('click', function() {
         document.getElementById('canvasBgColor').value = '#ffffff';
         document.getElementById('canvasBgHex').value = '#FFFFFF';
         document.getElementById('canvasBgColor').dispatchEvent(new Event('input'));
      });
      canvasBgBtns[1].addEventListener('click', function() {
         document.getElementById('canvasBgColor').value = '#000000';
         document.getElementById('canvasBgHex').value = '#000000';
         document.getElementById('canvasBgColor').dispatchEvent(new Event('input'));
      });
   }

   // Middle Area BG quick buttons (White/Black)
   document.querySelectorAll('#omius-app-root .middleBgQuickBtn').forEach(function(btn) {
      btn.addEventListener('click', function() {
         var color = btn.getAttribute('data-color');
         els.middleSelect.value = color;
         if (els.middleHex) els.middleHex.value = color.toUpperCase();
         els.logoArea.style.backgroundColor = color;
         // Sync panel background if "use same color" is checked
         var sameColorChk = document.getElementById('useSameColorPanel');
         if (sameColorChk && sameColorChk.checked) {
            els.canvasBg.value = color;
            var canvasBgHexEl = document.getElementById('canvasBgHex');
            if (canvasBgHexEl) canvasBgHexEl.value = color.toUpperCase();
            els.newCanvas.style.background = color;
         }
         updateHBPreview();
      });
   });

   // Initial render
   updateHBPreview();

   /* ═══════════════════════════════════════════════
      ADD TO CART (Webhook Flow)
      ═══════════════════════════════════════════════ */

 var VARIANT_CLASSIC = 46946888646807;
var VARIANT_WIDE = 46946888679575;
   var APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyGHUnz0qLTczGhf3WCAZ5x7PFBDeUO2oK0scU_Xhan9sGZmSbvGkpn6lYIywZnkVSl1w/exec';

   var addToCartBtn = document.getElementById('addToCartBtn');
   var sendOrderMsg = document.getElementById('sendOrderMsg');
   var isAddingToCart = false;

   // Generate unique ID
   function generateDesignId() {
      var chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
      var id = 'omius_';
      for (var i = 0; i < 5; i++) {
         id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
   }
// === GENERATE PRODUCTION PDF (cover + band lienzo + panel lienzo) ===
   function generateProduccionPdf(quantity, callback) {
      var lienzoW = 35;
      var lienzoH = 35;
      var bandW = 31;
      var bandH = currentModel === 'pro' ? 5.8 : 3.8;
      var bandCount = currentModel === 'pro' ? 6 : 9;
      var fabricColor = els.middleSelect.value;
      var panelEnabled = els.enablePanel.checked && state.panelSrc;
      var modelLabel = currentModel === 'pro' ? 'Wide' : 'Classic';

      var pdf = new jspdf.jsPDF({
         orientation: 'portrait',
         unit: 'cm',
         format: [lienzoW, lienzoH]
      });

      // ── PAGE 1: PRODUCTION INFO ──
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, lienzoW, lienzoH, 'F');

      pdf.setFontSize(22);
      pdf.setFont(undefined, 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('OMIUS — ORDEN DE SUBLIMACION', lienzoW / 2, 5, { align: 'center' });

      pdf.setDrawColor(0, 0, 0);
      pdf.setLineWidth(0.05);
      pdf.line(3, 6, lienzoW - 3, 6);

      var yPos = 9;

      // Rectangles info
      pdf.setFontSize(16);
      pdf.setFont(undefined, 'bold');
      pdf.text(quantity + ' Rectangulos', lienzoW / 2, yPos, { align: 'center' });
      yPos += 1.2;
      pdf.setFontSize(13);
      pdf.setFont(undefined, 'normal');
      pdf.text(bandW + ' cm ancho x ' + bandH + ' cm alto', lienzoW / 2, yPos, { align: 'center' });
      yPos += 2;

      // Panels info (if enabled)
      if (panelEnabled) {
         pdf.setFontSize(16);
         pdf.setFont(undefined, 'bold');
         pdf.text(quantity + ' Cuadros', lienzoW / 2, yPos, { align: 'center' });
         yPos += 1.2;
         pdf.setFontSize(13);
         pdf.setFont(undefined, 'normal');
         pdf.text('9.6 cm ancho x 8.5 cm alto', lienzoW / 2, yPos, { align: 'center' });
         yPos += 2;
      }

      yPos += 1;

      // Color swatches
      var r = parseInt(fabricColor.substr(1,2), 16);
      var g = parseInt(fabricColor.substr(3,2), 16);
      var b = parseInt(fabricColor.substr(5,2), 16);

      pdf.setFontSize(13);
      pdf.setFont(undefined, 'normal');
      pdf.text('Color tela:', 8, yPos);
      pdf.setFillColor(r, g, b);
      pdf.rect(15, yPos - 0.7, 1.5, 1, 'F');
      pdf.setDrawColor(180, 180, 180);
      pdf.setLineWidth(0.02);
      pdf.rect(15, yPos - 0.7, 1.5, 1, 'S');
      pdf.text(fabricColor.toUpperCase(), 17, yPos);

      if (panelEnabled) {
         yPos += 2;
         var pr = parseInt(els.canvasBg.value.substr(1,2), 16);
         var pg = parseInt(els.canvasBg.value.substr(3,2), 16);
         var pb = parseInt(els.canvasBg.value.substr(5,2), 16);
         pdf.text('Color panel:', 8, yPos);
         pdf.setFillColor(pr, pg, pb);
         pdf.rect(15, yPos - 0.7, 1.5, 1, 'F');
         pdf.setDrawColor(180, 180, 180);
         pdf.setLineWidth(0.02);
         pdf.rect(15, yPos - 0.7, 1.5, 1, 'S');
         pdf.text(els.canvasBg.value.toUpperCase(), 17, yPos);
      }

      // ── PAGE 2: BAND LIENZO ──
      pdf.addPage([lienzoW, lienzoH], 'portrait');
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, lienzoW, lienzoH, 'F');

      var totalBandsH = bandCount * bandH;
      var startY = (lienzoH - totalBandsH) / 2;
      var startX = (lienzoW - bandW) / 2;

      // Contrast color for cut lines
      var brightness = (r * 0.299 + g * 0.587 + b * 0.114);
      var cutR = brightness < 128 ? 255 : 0;
      var cutG = brightness < 128 ? 255 : 0;
      var cutB = brightness < 128 ? 255 : 0;

      for (var row = 0; row < bandCount; row++) {
         var y = startY + (row * bandH);
         pdf.setFillColor(r, g, b);
         pdf.rect(startX, y, bandW, bandH, 'F');
         pdf.setDrawColor(cutR, cutG, cutB);
         pdf.setLineWidth(0.0353);
         pdf.rect(startX, y, bandW, bandH, 'S');
      }

      if (!state.imgSrc) {
         finishBands();
         return;
      }

      var logoImg = new Image();
      logoImg.onload = function() {
         var scale = els.logoSize.value / 100;
         var imgRatio = logoImg.width / logoImg.height;
         var marginSide = 1;
         var marginTop = 1;
         var areaW = bandW - (marginSide * 2);
         var areaH = bandH - (marginTop * 2);

         for (var row = 0; row < bandCount; row++) {
            var y = startY + (row * bandH);

            if (state.isRepeated) {
               var count = parseInt(els.logoCount.value) || 3;
               var slotW = areaW / count;
               var logoH = areaH * scale;
               var logoW = logoH * imgRatio;
               if (logoW > slotW * 0.9) { logoW = slotW * 0.9; logoH = logoW / imgRatio; }
               if (logoH > areaH) { logoH = areaH; logoW = logoH * imgRatio; }
               for (var i = 0; i < count; i++) {
                  var cx = startX + marginSide + (slotW * i) + (slotW - logoW) / 2;
                  var cy = y + marginTop + (areaH - logoH) / 2;
                  pdf.addImage(state.imgSrc, 'PNG', cx, cy, logoW, logoH, 'bandlogo', 'FAST');
               }
            } else {
               var logoH = areaH * scale;
               var logoW = logoH * imgRatio;
               if (logoW > areaW) { logoW = areaW; logoH = logoW / imgRatio; }
               if (logoH > areaH) { logoH = areaH; logoW = logoH * imgRatio; }
               var cx = startX + marginSide + (areaW - logoW) / 2;
               var cy = y + marginTop + (areaH - logoH) / 2;
               pdf.addImage(state.imgSrc, 'PNG', cx, cy, logoW, logoH, 'bandlogo', 'FAST');
            }
         }

         finishBands();
      };
      logoImg.src = state.imgSrc;

      function finishBands() {
         if (!panelEnabled) {
            callback(pdf.output('datauristring'));
            return;
         }

         // ── PAGE 3: PANEL LIENZO ──
         pdf.addPage([lienzoW, lienzoH], 'portrait');
         pdf.setFillColor(255, 255, 255);
         pdf.rect(0, 0, lienzoW, lienzoH, 'F');

         var panelW = 9.6;
         var panelH2 = 8.5;
         var cols = 3;
         var rows2 = 4;
         var totalW = cols * panelW;
         var totalH = rows2 * panelH2;
         var pStartX = (lienzoW - totalW) / 2;
         var pStartY = (lienzoH - totalH) / 2;

         var pr = parseInt(els.canvasBg.value.substr(1,2), 16);
         var pg = parseInt(els.canvasBg.value.substr(3,2), 16);
         var pb = parseInt(els.canvasBg.value.substr(5,2), 16);

         var pBrightness = (pr * 0.299 + pg * 0.587 + pb * 0.114);
         var pCutR = pBrightness < 128 ? 255 : 0;
         var pCutG = pBrightness < 128 ? 255 : 0;
         var pCutB = pBrightness < 128 ? 255 : 0;

         for (var row = 0; row < rows2; row++) {
            for (var col = 0; col < cols; col++) {
               var x = pStartX + (col * panelW);
               var y2 = pStartY + (row * panelH2);
               pdf.setFillColor(pr, pg, pb);
               pdf.rect(x, y2, panelW, panelH2, 'F');
               pdf.setDrawColor(pCutR, pCutG, pCutB);
               pdf.setLineWidth(0.0353);
               pdf.rect(x, y2, panelW, panelH2, 'S');
            }
         }

         if (!state.panelSrc) {
            callback(pdf.output('datauristring'));
            return;
         }

         var panelLogoImg = new Image();
         panelLogoImg.onload = function() {
            var pScale = els.canvasSize.value / 100;
            var marginCm = 1.5;
            var pareaW = panelW - (marginCm * 2);
            var pareaH = panelH2 - (marginCm * 2);
            var pRatio = panelLogoImg.width / panelLogoImg.height;
            var pH = pareaH * pScale;
            var pW = pH * pRatio;
            if (pW > pareaW) { pW = pareaW; pH = pW / pRatio; }

            for (var row = 0; row < rows2; row++) {
               for (var col = 0; col < cols; col++) {
                  var x = pStartX + (col * panelW);
                  var y2 = pStartY + (row * panelH2);
                  var px = x + marginCm + (pareaW - pW) / 2;
                  var py = y2 + marginCm + (pareaH - pH) / 2;
                  pdf.addImage(state.panelSrc, 'PNG', px, py, pW, pH, 'panellogo', 'FAST');
               }
            }

            callback(pdf.output('datauristring'));
         };
         panelLogoImg.src = state.panelSrc;
      }
   }
   // Generate sublimation PDF as base64
   function generateSubPdfBase64(callback) {
      var model = currentModel;
      var bandW_cm = 31;
      var bandH_cm = model === 'pro' ? 5.8 : 3.8;
      var fabricColor = els.middleSelect.value;

      var pdf = new jspdf.jsPDF({
         orientation: 'landscape',
         unit: 'cm',
         format: [bandH_cm, bandW_cm]
      });

      var r = parseInt(fabricColor.substr(1,2), 16);
      var g = parseInt(fabricColor.substr(3,2), 16);
      var b = parseInt(fabricColor.substr(5,2), 16);
      pdf.setFillColor(r, g, b);
      pdf.rect(0, 0, bandW_cm, bandH_cm, 'F');

      if (!state.imgSrc) {
         finishPdf(pdf);
         return;
      }

     var logoImg = new Image();
      logoImg.onload = function() {
         var scale = els.logoSize.value / 100;
         var imgRatio = logoImg.width / logoImg.height;
         var marginSide = 1;
         var marginTop = 1;
         var areaW = bandW_cm - (marginSide * 2);
         var areaH = bandH_cm - (marginTop * 2);

         if (state.isRepeated) {
            var count = parseInt(els.logoCount.value) || 3;
            var slotW = areaW / count;
            var logoH = areaH * scale;
            var logoW = logoH * imgRatio;
            if (logoW > slotW * 0.9) { logoW = slotW * 0.9; logoH = logoW / imgRatio; }
            if (logoH > areaH) { logoH = areaH; logoW = logoH * imgRatio; }
            for (var i = 0; i < count; i++) {
               var cx = marginSide + (slotW * i) + (slotW - logoW) / 2;
               var cy = marginTop + (areaH - logoH) / 2;
               pdf.addImage(state.imgSrc, 'PNG', cx, cy, logoW, logoH, '', 'NONE');
            }
         } else {
            var logoH = areaH * scale;
            var logoW = logoH * imgRatio;
            if (logoW > areaW) { logoW = areaW; logoH = logoW / imgRatio; }
            if (logoH > areaH) { logoH = areaH; logoW = logoH * imgRatio; }
            var cx = marginSide + (areaW - logoW) / 2;
            var cy = marginTop + (areaH - logoH) / 2;
            pdf.addImage(state.imgSrc, 'PNG', cx, cy, logoW, logoH, '', 'NONE');
         }

         // Panel page
         if (els.enablePanel.checked && state.panelSrc) {
            var panelW = 9.6, panelH = 8.5;
            pdf.addPage([panelH, panelW], 'landscape');
            var pr = parseInt(els.canvasBg.value.substr(1,2), 16);
            var pg = parseInt(els.canvasBg.value.substr(3,2), 16);
            var pb = parseInt(els.canvasBg.value.substr(5,2), 16);
            pdf.setFillColor(pr, pg, pb);
            pdf.rect(0, 0, panelW, panelH, 'F');

            var panelImg = new Image();
            panelImg.onload = function() {
               var pScale = els.canvasSize.value / 100;
               var marginCm = 1.5;
               var areaW = panelW - (marginCm * 2);
               var areaH = panelH - (marginCm * 2);
               var pRatio = panelImg.width / panelImg.height;
               var pH = areaH * pScale;
               var pW = pH * pRatio;
               if (pW > areaW) { pW = areaW; pH = pW / pRatio; }
               var px = marginCm + (areaW - pW) / 2;
               var py = marginCm + (areaH - pH) / 2;
               pdf.addImage(state.panelSrc, 'PNG', px, py, pW, pH, '', 'NONE');
               finishPdf(pdf);
            };
            panelImg.src = state.panelSrc;
         } else {
            finishPdf(pdf);
         }
      };
      logoImg.src = state.imgSrc;

      function finishPdf(pdf) {
         callback(pdf.output('datauristring'));
      }
   }

   // Capture preview image (front + back)
   function capturePreviewImage(callback) {
      var previewSection = document.getElementById('hbPreviewSection');
      var viewCards = previewSection ? previewSection.querySelectorAll('.hb-view-card') : [];
      var frontCard = viewCards[0] || null;
      var backCard = viewCards[1] || null;
      var captureOpt = { scale: 1.5, useCORS: true, backgroundColor: '#ffffff', allowTaint: true, logging: false, imageTimeout: 0 };

      var captures = [];
      if (frontCard) captures.push(html2canvas(frontCard, captureOpt));
      if (backCard) captures.push(html2canvas(backCard, captureOpt));

      if (captures.length === 0) { callback(''); return; }

      Promise.all(captures).then(function(canvases) {
         var totalW = 0, maxH = 0;
         canvases.forEach(function(c) { totalW += c.width; if (c.height > maxH) maxH = c.height; });
         var gap = 20;
         var combined = document.createElement('canvas');
         combined.width = totalW + gap;
         combined.height = maxH;
         var ctx = combined.getContext('2d');
         ctx.fillStyle = '#ffffff';
         ctx.fillRect(0, 0, combined.width, combined.height);
         var xOff = 0;
         canvases.forEach(function(c) { ctx.drawImage(c, xOff, 0); xOff += c.width + gap; });
         callback(combined.toDataURL('image/jpeg', 0.7));
      }).catch(function() { callback(''); });
   }

   // Capture preview FRONT and BACK as SEPARATE images (for brand mode)
   // Returns { front: dataUrl, back: dataUrl } via callback
   function capturePreviewSeparate(callback) {
      var previewSection = document.getElementById('hbPreviewSection');
      var viewCards = previewSection ? previewSection.querySelectorAll('.hb-view-card') : [];
      var frontCard = viewCards[0] || null;
      var backCard = viewCards[1] || null;
      var captureOpt = { scale: 3, useCORS: true, backgroundColor: '#ffffff', allowTaint: true, logging: false, imageTimeout: 0 };

      if (!frontCard && !backCard) { callback({ front: '', back: '' }); return; }

      var promises = [];
      promises.push(frontCard ? html2canvas(frontCard, captureOpt) : Promise.resolve(null));
      promises.push(backCard ? html2canvas(backCard, captureOpt) : Promise.resolve(null));

      Promise.all(promises).then(function(canvases) {
         var frontData = '';
         var backData = '';

         if (canvases[0]) {
            // Wrap front canvas with white padding for a cleaner product look
            var fc = canvases[0];
            var padded = document.createElement('canvas');
            var padding = 60;
            padded.width = fc.width + (padding * 2);
            padded.height = fc.height + (padding * 2);
            var ctx = padded.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, padded.width, padded.height);
            ctx.drawImage(fc, padding, padding);
            frontData = padded.toDataURL('image/jpeg', 0.95);
         }

         if (canvases[1]) {
            var bc = canvases[1];
            var padded2 = document.createElement('canvas');
            var padding = 60;
            padded2.width = bc.width + (padding * 2);
            padded2.height = bc.height + (padding * 2);
            var ctx2 = padded2.getContext('2d');
            ctx2.fillStyle = '#ffffff';
            ctx2.fillRect(0, 0, padded2.width, padded2.height);
            ctx2.drawImage(bc, padding, padding);
            backData = padded2.toDataURL('image/jpeg', 0.95);
         }

         callback({ front: frontData, back: backData });
      }).catch(function() { callback({ front: '', back: '' }); });
   }

   // Upload a file to Apps Script
   function uploadToAppsScript(folderId, fileName, fileData, mimeType) {
      return fetch(APPS_SCRIPT_URL, {
         method: 'POST',
         headers: { 'Content-Type': 'text/plain' },
         body: JSON.stringify({
            action: 'upload_file',
            folderId: folderId,
            fileName: fileName,
            fileData: fileData,
            mimeType: mimeType
         })
      }).then(function(r) { return r.text(); })
        .then(function(t) {
           var result;
           try { result = JSON.parse(t); } catch(e) { throw new Error('Parse error: ' + t.substring(0, 200)); }
           if (!result.success) throw new Error(result.error || 'Upload failed');
           return result;
        });
   }

   // Show progress
   function updateProgress(msg) {
      if (sendOrderMsg) {
         sendOrderMsg.style.display = 'block';
         sendOrderMsg.innerHTML = '<span style="color: #666;">⏳ ' + msg + '</span>';
      }
   }

   if (addToCartBtn) {
      addToCartBtn.onclick = function() {
         if (isAddingToCart) return;
         isAddingToCart = true;
         var customerNotes = document.getElementById('customerNotes');

         // ── VALIDATE ──
         if (!state.imgSrc) {
            sendOrderMsg.style.display = 'block';
            sendOrderMsg.innerHTML = '<span style="color: #dc3545;">❌ Please upload a logo before submitting.</span>';
            isAddingToCart = false;
            return;
         }

         // ── BRAND MODE: go through separate flow ──
         if (isBrandMode) {
            handleBrandSubmit();
            return;
         }

         var qty = document.getElementById('orderQuantity');
         if (!qty || !qty.value || parseInt(qty.value) < 15) {
            sendOrderMsg.style.display = 'block';
            sendOrderMsg.innerHTML = '<span style="color: #dc3545;">❌ Minimum order is 15 units.</span>';
            isAddingToCart = false;
            var step2Body = document.getElementById('step2Body');
            if (step2Body && !step2Body.classList.contains('step-open')) {
               document.getElementById('step2').querySelector('.step-header').click();
            }
            setTimeout(function() {
               qty.scrollIntoView({ behavior: 'smooth', block: 'center' });
               qty.focus();
               qty.style.border = '2px solid #dc3545';
               setTimeout(function() { qty.style.border = ''; }, 3000);
            }, 400);
            return;
         }

         // ── START PROCESS ──
         var designId = generateDesignId();
         var specs = getDesignSpecs();
         var biasTape = els.stripeSelect.value === 'white' ? 'White' : 'Black';
         var qtyVal = qty.value;
         var modelName = currentModel === 'pro' ? 'Wide' : 'Classic';
         var panelBgText = specs.panelEnabled ? specs.panelBg + ' (' + hexToRgb(specs.panelBg) + ')' : 'N/A';
         var panelSizeText = specs.panelEnabled ? specs.panelSize : 'N/A';

         addToCartBtn.innerText = '⏳ Preparing files...';
         addToCartBtn.disabled = true;
         updateProgress('Creating folder...');

         // ── STEP 1: CREATE TMP FOLDER ──
         var omius_folderId = null;
         fetch(APPS_SCRIPT_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify({
               action: 'create_tmp_folder',
               uniqueId: designId
            })
         })
         .then(function(r) { return r.text(); })
         .then(function(t) {
            var result;
            try { result = JSON.parse(t); } catch(e) { throw new Error('Parse error: ' + t.substring(0, 200)); }
            if (!result.success) throw new Error(result.error || 'Failed to create folder');

            var folderId = result.folderId;
            omius_folderId = folderId;
            console.log('[OMIUS] TMP folder created:', result.folderName);
            updateProgress('Generating print file...');
// ── STEPS 2-4: GENERATE & UPLOAD ALL FILES IN PARALLEL ──
            updateProgress('Generating files...');

            var uploadPromises = [];

            // Upload 1: Sublimation PDF
            uploadPromises.push(new Promise(function(resolve) {
               generateSubPdfBase64(function(pdfBase64) {
                  uploadToAppsScript(folderId, 'OMIUS-Sublimation-' + modelName + '.pdf', pdfBase64, 'application/pdf')
                     .then(resolve).catch(resolve);
               });
            }));

            // Upload 2: Original logo
            uploadPromises.push(
               uploadToAppsScript(folderId, 'original-logo.png', state.imgSrc, 'image/png')
                  .catch(function() {})
            );

            // Upload 3: Preview image
            uploadPromises.push(new Promise(function(resolve) {
               capturePreviewImage(function(previewDataUrl) {
                  if (previewDataUrl) {
                     uploadToAppsScript(folderId, 'design-preview.jpg', previewDataUrl, 'image/jpeg')
                        .then(resolve).catch(resolve);
                  } else { resolve(); }
               });
            }));

      // Upload 4: Production PDF (cover + bands + panels)
            uploadPromises.push(new Promise(function(resolve) {
               generateProduccionPdf(qtyVal, function(pdfBase64) {
                  uploadToAppsScript(folderId, 'OMIUS-Produccion-' + modelName + '-' + qtyVal + 'pz.pdf', pdfBase64, 'application/pdf')
                     .then(resolve).catch(resolve);
               });
            }));

            // Upload 6: Order details JSON
            var orderDetails = {
               designId: designId,
               quantity: qtyVal,
               model: specs.model,
               fabricColor: specs.fabricColor,
               biasTape: biasTape,
               placement: specs.placement,
               logoSize: specs.logoSize,
               frontPanel: specs.panelEnabled ? 'Yes' : 'No',
               panelBg: panelBgText,
               panelSize: panelSizeText,
               notes: customerNotes && customerNotes.value.trim() ? customerNotes.value.trim() : 'None',
               savedAt: new Date().toISOString()
            };
            var jsonBlob = 'data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(orderDetails, null, 2))));
            uploadPromises.push(
               uploadToAppsScript(folderId, 'order-details.json', jsonBlob, 'application/json')
                  .catch(function() {})
            );

            updateProgress('Uploading files...');
            return Promise.all(uploadPromises);
         })
         .then(function(uploadResults) {
            // ── STEP 5: ADD TO CART VIA REDIRECT ──
            // Using cart/{variantId}:{qty} URL because it works with "Unlisted" products.
            // Design details are already saved in Drive (order-details.json), so we only
            // need the variant, quantity, and design ID note in the cart.
            updateProgress('Adding to cart...');

            var variantId = currentModel === 'pro' ? VARIANT_WIDE : VARIANT_CLASSIC;
            console.log('[OMIUS] Redirecting to cart with variant:', variantId, 'qty:', qtyVal);

            // Simple cart URL: just variant:qty + note with design ID
            addToCartBtn.innerText = '✅ Redirecting to cart...';
addToCartBtn.style.backgroundColor = '#28a745';

fetch('/cart/add.js', {
   method: 'POST',
   headers: { 'Content-Type': 'application/json' },
   body: JSON.stringify({
      items: [{
         id: variantId,
         quantity: parseInt(qtyVal),
         properties: { '_omius_design_id': designId }
      }]
   })
}).then(function(r) { return r.json(); })
  .then(function() {
     console.log('[OMIUS] Added to cart with design ID property:', designId);
     return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: 'omius_design_id:' + designId })
     }).catch(function(){});
  })
  .then(function() {
     window.location.href = '/cart';
  })
  .catch(function(err) {
     console.error('[OMIUS] Add to cart error:', err);
     window.location.href = '/cart';
  });
            return null;
         })
         .catch(function(error) {
            console.error('[OMIUS] ❌ Error:', error);
            addToCartBtn.innerText = '🛒 ADD TO CART — $' + (currentModel === 'pro' ? '35.00' : '30.00');
            addToCartBtn.style.backgroundColor = '#e67e22';
            addToCartBtn.disabled = false;
            isAddingToCart = false;
            sendOrderMsg.style.display = 'block';
            sendOrderMsg.innerHTML = '<span style="color: #dc3545;">❌ Error: ' + error.message + '. Please try again.</span>';
         });
      };
   }

   /* ═══════════════════════════════════════════════
      BRAND MODE: Submit Design Flow
      ═══════════════════════════════════════════════ */

   function handleBrandSubmit() {
      var customerNotes = document.getElementById('customerNotes');

      // ── VALIDATE TEAM/BRAND NAME ──
      var teamNameInput = document.getElementById('brandTeamName');
      var teamNameError = document.getElementById('brandTeamNameError');
      var teamName = teamNameInput && teamNameInput.value ? teamNameInput.value.trim() : '';

      if (!teamName) {
         // Show error, scroll to top, focus the field
         if (teamNameError) teamNameError.style.display = 'block';
         if (teamNameInput) {
            teamNameInput.style.boxShadow = '0 0 0 3px #ffd700';
            teamNameInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function() { teamNameInput.focus(); }, 400);
         }
         isAddingToCart = false;
         return;
      }

      // Clear error if any
      if (teamNameError) teamNameError.style.display = 'none';
      if (teamNameInput) teamNameInput.style.boxShadow = '';

      // Confirmation popup
      var confirmed = confirm(
         'Ready to submit your final design for "' + teamName + '"?\n\n' +
         'This design will be used to produce your team\'s headbands. ' +
         'Once submitted, if you need changes, please contact your Omius representative.'
      );

      if (!confirmed) {
         isAddingToCart = false;
         return;
      }

      // Start process
      var designId = generateDesignId();
      var specs = getDesignSpecs();
      var biasTape = els.stripeSelect.value === 'white' ? 'White' : 'Black';
      var modelName = currentModel === 'pro' ? 'Wide' : 'Classic';
      var panelBgText = specs.panelEnabled ? specs.panelBg + ' (' + hexToRgb(specs.panelBg) + ')' : 'N/A';
      var panelSizeText = specs.panelEnabled ? specs.panelSize : 'N/A';

      addToCartBtn.innerText = '⏳ Preparing files...';
      addToCartBtn.disabled = true;
      updateProgress('Creating folder...');

      // STEP 1: Create BRAND folder in Drive
      fetch(APPS_SCRIPT_URL, {
         method: 'POST',
         headers: { 'Content-Type': 'text/plain' },
         body: JSON.stringify({
            action: 'create_brand_folder',
            uniqueId: designId
         })
      })
      .then(function(r) { return r.text(); })
      .then(function(t) {
         var result;
         try { result = JSON.parse(t); } catch(e) { throw new Error('Parse error: ' + t.substring(0, 200)); }
         if (!result.success) throw new Error(result.error || 'Failed to create folder');

         var folderId = result.folderId;
         console.log('[OMIUS] BRAND folder created:', result.folderName);
         updateProgress('Generating files...');

         var uploadPromises = [];

         // Upload 1: Sublimation PDF
         uploadPromises.push(new Promise(function(resolve) {
            generateSubPdfBase64(function(pdfBase64) {
               uploadToAppsScript(folderId, 'OMIUS-Sublimation-' + modelName + '.pdf', pdfBase64, 'application/pdf')
                  .then(resolve).catch(resolve);
            });
         }));

         // Upload 2: Original logo
         uploadPromises.push(
            uploadToAppsScript(folderId, 'original-logo.png', state.imgSrc, 'image/png')
               .catch(function() {})
         );

         // Upload 3: Preview images (FRONT + BACK separate, for brand mode)
         uploadPromises.push(new Promise(function(resolve) {
            capturePreviewSeparate(function(previews) {
               var subPromises = [];
               if (previews.front) {
                  subPromises.push(
                     uploadToAppsScript(folderId, 'preview-front.jpg', previews.front, 'image/jpeg')
                        .catch(function() {})
                  );
               }
               if (previews.back) {
                  subPromises.push(
                     uploadToAppsScript(folderId, 'preview-back.jpg', previews.back, 'image/jpeg')
                        .catch(function() {})
                  );
               }
               Promise.all(subPromises).then(resolve).catch(resolve);
            });
         }));

         // Upload 4: Order details JSON (no quantity in brand mode)
         var orderDetails = {
            designId: designId,
            mode: 'brand',
            teamName: teamName,
            model: specs.model,
            fabricColor: specs.fabricColor,
            biasTape: biasTape,
            placement: specs.placement,
            logoSize: specs.logoSize,
            frontPanel: specs.panelEnabled ? 'Yes' : 'No',
            panelBg: panelBgText,
            panelSize: panelSizeText,
            notes: customerNotes && customerNotes.value.trim() ? customerNotes.value.trim() : 'None',
            submittedAt: new Date().toISOString()
         };
         var jsonBlob = 'data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(orderDetails, null, 2))));
         uploadPromises.push(
            uploadToAppsScript(folderId, 'order-details.json', jsonBlob, 'application/json')
               .catch(function() {})
         );

         updateProgress('Uploading files...');
         return Promise.all(uploadPromises);
      })
      .then(function(uploadResults) {
         // STEP 2: Submit brand design (renames folder + sends email)
         updateProgress('Submitting design...');

         return fetch(APPS_SCRIPT_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify({
               action: 'submit_brand_design',
               uniqueId: designId,
               teamName: teamName,
               model: specs.model,
               fabricColor: specs.fabricColor,
               biasTape: biasTape,
               placement: specs.placement,
               logoSize: specs.logoSize,
               frontPanel: specs.panelEnabled ? 'Yes' : 'No',
               panelBg: panelBgText,
               panelSize: panelSizeText,
               notes: customerNotes && customerNotes.value.trim() ? customerNotes.value.trim() : 'None'
            })
         }).then(function(r) { return r.text(); });
      })
      .then(function(t) {
         var result;
         try { result = JSON.parse(t); } catch(e) { result = { success: true }; }

         console.log('[OMIUS] ✅ Brand design submitted:', designId);

         addToCartBtn.innerText = '✅ Design Submitted!';
         addToCartBtn.style.backgroundColor = '#28a745';
         sendOrderMsg.style.display = 'block';
         sendOrderMsg.innerHTML = '<span style="color: #28a745; font-size: 15px;">✅ <strong>Design submitted successfully!</strong><br>Your Omius representative will contact you with your team store link soon.</span>';

         // Keep button disabled so they don't submit twice
         addToCartBtn.disabled = true;
      })
      .catch(function(error) {
         console.error('[OMIUS] ❌ Brand submit error:', error);
         addToCartBtn.innerText = '📤 SUBMIT DESIGN';
         addToCartBtn.style.backgroundColor = '#e67e22';
         addToCartBtn.disabled = false;
         isAddingToCart = false;
         sendOrderMsg.style.display = 'block';
         sendOrderMsg.innerHTML = '<span style="color: #dc3545;">❌ Error: ' + error.message + '. Please try again.</span>';
      });
   }

   /* ═══════════════════════════════════════════════
      BRAND MODE: UI adjustments
      ═══════════════════════════════════════════════ */

   if (isBrandMode) {
      // Banner at top with Team/Brand name input
      var appRoot = document.getElementById('omius-app-root');
      if (appRoot) {
         var banner = document.createElement('div');
         banner.style.cssText = 'background: linear-gradient(90deg, #4a90d9, #5ba3e8); color: white; padding: 16px 20px; margin-bottom: 20px; border-radius: 6px;';
         banner.innerHTML =
            '<div style="text-align: center; font-weight: bold; font-size: 15px; margin-bottom: 12px;">' +
               '🎨 TEAM DESIGN MODE — Design your custom headband. Submit when ready.' +
            '</div>' +
            '<div style="max-width: 480px; margin: 0 auto;">' +
               '<label for="brandTeamName" style="display: block; font-size: 13px; font-weight: 600; margin-bottom: 6px; color: white;">' +
                  'Team or Brand Name <span style="color: #ffd700;">*</span>' +
               '</label>' +
               '<input type="text" id="brandTeamName" placeholder="e.g. Swatt Club" maxlength="80" ' +
                  'style="width: 100%; padding: 10px 12px; font-size: 15px; border: none; border-radius: 6px; outline: none; box-sizing: border-box; font-family: inherit;">' +
               '<div id="brandTeamNameError" style="display: none; color: #ffd700; font-size: 12px; margin-top: 6px; font-weight: 600;">' +
                  '❌ Please enter your team or brand name before submitting.' +
               '</div>' +
            '</div>';
         appRoot.insertBefore(banner, appRoot.firstChild);
      }

      // Hide quantity field (not needed in brand mode)
      var qtyField = document.getElementById('orderQuantity');
      if (qtyField) {
         var qtyWrap = qtyField.closest('div');
         // Walk up to find the containing group
         var parent = qtyField.parentElement;
         while (parent && parent.id !== 'step2Body' && parent.id !== 'omius-app-root') {
            if (parent.tagName === 'DIV' && (parent.querySelector('label') || parent.querySelector('input[type="number"]'))) {
               if (parent.children.length <= 4) {
                  parent.style.display = 'none';
                  break;
               }
            }
            parent = parent.parentElement;
         }
      }

      // Change button text (will be hidden until logo is uploaded)
      var brandBtn = document.getElementById('addToCartBtn');
      if (brandBtn) {
         brandBtn.innerText = '📤 SUBMIT DESIGN';
         brandBtn.style.backgroundColor = '#4a90d9';
         brandBtn.style.display = 'none'; // Hidden until logo uploaded
      }

      // Show/hide button based on logo upload
      var brandBtnInterval = setInterval(function() {
         var btn = document.getElementById('addToCartBtn');
         if (!btn) return;
         if (state.imgSrc && btn.style.display === 'none') {
            btn.style.display = '';
         } else if (!state.imgSrc && btn.style.display !== 'none') {
            btn.style.display = 'none';
         }
      }, 500);
   }
}